import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
// Map imports removed
import { 
  Activity, RefreshCw, Plus, Edit, Trash2, ArrowLeft, 
  MapPin, Clock, Wifi, WifiOff, AlertCircle, Search, Filter,
  ChevronDown, ChevronUp, Users, Bell, Shield, Mail, Radio, LogIn, Copy, CheckCircle, ExternalLink, Ticket, MessageSquare, User, Send, X,
  Power, Globe, FileText, Settings, Brain, Phone, Zap, Building2, Download
} from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { toast } from 'sonner';
import { TricolorWaveBackground, isIndependenceThemeActive } from '../../components/dashboard/IndependenceDayBanner';
import InternalChat from '../../components/InternalChat';
import InactiveCustomerAlerts from '../../components/dashboard/InactiveCustomerAlerts';
import WeatherAlerts from '../../components/dashboard/WeatherAlerts';
import BandwidthMonitoring from '../../components/dashboard/BandwidthMonitoring';
import PartnerDashboard from '../../components/dashboard/PartnerDashboard';
// Leaflet CSS import removed

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Map-related functions removed

const CustomerMonitoring = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [editingCustomer, setEditingCustomer] = useState(null);
  const [liveMode, setLiveMode] = useState(true);
  const [lastUpdate, setLastUpdate] = useState(new Date());
  const [nextRefresh, setNextRefresh] = useState(10);
  const [formData, setFormData] = useState({
    customer_name: '',
    office_name: '',
    static_ip: '',
    circuit_id: '',
    backend_partner: 'Netix',
    city: '',
    state: '',
    email: '',
    is_suspended: false,
    isp: 'Netix',
    managed_by: 'Netix',
    service: 'Lease Line',
    broadband_account_number: '',
    last_recharge_date: '',
    last_recharge_amount: '',
    plan_speed: '',
    plan_duration_months: '',
    router_name: '',
    router_model: '',
    router_ip: '',
    router_username: '',
    router_password: '',
    ticket_approved: false
  });
  const [expandedCards, setExpandedCards] = useState(new Set());
  const [expandedRecharge, setExpandedRecharge] = useState(new Set());
  const [networkUptime, setNetworkUptime] = useState(99.5);
  const [showRouterPassword, setShowRouterPassword] = useState(false);
  const [userPermissions, setUserPermissions] = useState({
    can_add_customer: true,
    can_edit_customer: true,
    can_delete_customer: true,
    can_manage_users: true,
    can_view_alerts: true,
    can_view_analytics: true,
    can_view_quality_metrics: true,
    can_view_topology: true,
    can_view_diagnostics: true,
    can_view_performance_map: true,
    can_access_whatsapp: true
  });
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [announcement, setAnnouncement] = useState({ message: '', is_active: false });
  const [showAnnouncementModal, setShowAnnouncementModal] = useState(false);
  const [announcementInput, setAnnouncementInput] = useState('');
  const [showNetworkDashboard, setShowNetworkDashboard] = useState(false);
  const [showLiveStatus, setShowLiveStatus] = useState(false);
  const [showCustomerTable, setShowCustomerTable] = useState(false); // Collapsed by default
  // mapRef removed
  const modalRef = useRef(null);
  
  // Router Management States
  const [showRouterModal, setShowRouterModal] = useState(false);
  const [routerCredentials, setRouterCredentials] = useState(null);
  const [loadingRouter, setLoadingRouter] = useState(false);
  const [copiedField, setCopiedField] = useState(null);
  
  // Ticket System States
  const [showTicketsCard, setShowTicketsCard] = useState(true);
  const [showLogTicketModal, setShowLogTicketModal] = useState(false);
  const [showTicketDetailModal, setShowTicketDetailModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [ticketStats, setTicketStats] = useState({});
  const [approvedCustomers, setApprovedCustomers] = useState([]);
  const [ticketFormData, setTicketFormData] = useState({
    customer_id: '',
    customer_name: '',
    category: 'Technical',
    priority: 'Medium',
    subject: '',
    description: '',
    customer_ip: '',
    customer_email: ''
  });
  const [ticketReplies, setTicketReplies] = useState([]);
  const [replyMessage, setReplyMessage] = useState('');
  const [sendingReply, setSendingReply] = useState(false);
  
  // Router Control States
  const [showRouterControlModal, setShowRouterControlModal] = useState(false);
  const [showRouterLogsModal, setShowRouterLogsModal] = useState(false);
  const [selectedRouterCustomer, setSelectedRouterCustomer] = useState(null);
  const [routerLogs, setRouterLogs] = useState('');
  const [routerMockMode, setRouterMockMode] = useState(true);
  const [routerActionInProgress, setRouterActionInProgress] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);

  // Decode JWT token to get user permissions
  const getUserPermissions = () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      if (!token) return null;
      
      // Decode JWT (simple base64 decode of payload)
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(window.atob(base64));
      
      // If admin, grant all permissions
      if (payload.user_type === 'admin') {
        return {
          can_add_customer: true,
          can_edit_customer: true,
          can_delete_customer: true,
          can_manage_users: true,
          can_refresh_status: true,
          can_view_alerts: true,
          can_view_analytics: true,
          can_view_quality_metrics: true,
          can_view_topology: true,
          can_view_diagnostics: true,
          can_view_performance_map: true
        };
      }
      
      // Sub-user permissions from token
      return payload.permissions || {};
    } catch (error) {
      console.error('Error decoding token:', error);
      return {
        can_add_customer: false,
        can_edit_customer: false,
        can_delete_customer: false,
        can_manage_users: false,
        can_refresh_status: true,
        can_view_alerts: false,
        can_view_analytics: false,
        can_view_quality_metrics: false,
        can_view_topology: false,
        can_view_diagnostics: false,
        can_view_performance_map: false
      };
    }
  };

  useEffect(() => {
    // Load user permissions on mount
    const permissions = getUserPermissions();
    if (permissions) {
      setUserPermissions(permissions);
    }
  }, []);

  const toggleCardExpanded = (customerId) => {
    setExpandedCards(prev => {
      const newSet = new Set(prev);
      if (newSet.has(customerId)) {
        newSet.delete(customerId);
      } else {
        newSet.add(customerId);
      }
      return newSet;
    });
  };

  useEffect(() => {
    fetchCustomers();
    fetchProfilePhoto();
    fetchAnnouncement();
    
    // Live mode: refresh every 10 seconds for real-time monitoring
    const refreshInterval = setInterval(() => {
      if (liveMode) {
        fetchCustomers(true);
        setLastUpdate(new Date());
        setNextRefresh(10);
      }
    }, 10 * 1000); // 10 seconds
    
    // Countdown timer
    const countdownInterval = setInterval(() => {
      if (liveMode) {
        setNextRefresh(prev => prev > 0 ? prev - 1 : 10);
      }
    }, 1000);
    
    return () => {
      clearInterval(refreshInterval);
      clearInterval(countdownInterval);
    };
  }, [liveMode]);

  // Reset modal scroll position when it opens
  useEffect(() => {
    if (showAddModal && modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [showAddModal]);

  useEffect(() => {
    // Filter customers based on search and status
    let filtered = customers;
    
    if (searchTerm) {
      filtered = filtered.filter(c => 
        c.customer_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.office_name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.static_ip.includes(searchTerm)
      );
    }
    
    if (statusFilter !== 'all') {
      filtered = filtered.filter(c => c.status === statusFilter);
    }
    
    setFilteredCustomers(filtered);
  }, [searchTerm, statusFilter, customers]);

  // Auto-refresh Network Health every 5 minutes
  useEffect(() => {
    const healthRefreshInterval = setInterval(() => {
      fetchCustomers(); // Refresh customer data to update health percentage
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(healthRefreshInterval);
  }, []);

  // Auto-refresh Network Uptime every 15 minutes
  useEffect(() => {
    const fetchNetworkUptime = async () => {
      try {
        const token = localStorage.getItem('monitoringAdminToken');
        const response = await fetch(`${API_URL}/api/monitoring/network-uptime`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (response.ok) {
          const data = await response.json();
          setNetworkUptime(data.uptime_percentage || 99.5);
        }
      } catch (error) {
        console.error('Error fetching network uptime:', error);
        // Keep current value or set default
      }
    };

    fetchNetworkUptime();
    const uptimeRefreshInterval = setInterval(fetchNetworkUptime, 15 * 60 * 1000); // 15 minutes

    return () => clearInterval(uptimeRefreshInterval);
  }, []);
  // Fetch tickets on load
  useEffect(() => {
    if (userPermissions.can_view_customer) {
      fetchTickets();
      fetchTicketStats();
      const interval = setInterval(() => {
        fetchTickets();
        fetchTicketStats();
      }, 2 * 60 * 1000); // Refresh every 2 minutes
      return () => clearInterval(interval);
    }
  }, [userPermissions]);

  // Fetch router mock mode on load (admin only)
  useEffect(() => {
    if (userPermissions.can_manage_users) {
      fetchRouterMockMode();
    }
  }, [userPermissions]);

  const fetchProfilePhoto = async () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      if (!token) return;
      
      const response = await fetch(`${API_URL}/api/monitoring/profile/photo`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (response.ok) {
        const data = await response.json();
        if (data.profilePhoto) {
          setProfilePhoto(data.profilePhoto);
        }
      }
    } catch (error) {
      console.error('Error fetching profile photo:', error);
    }
  };

  const fetchAnnouncement = async () => {
    try {
      const response = await fetch(`${API_URL}/api/monitoring/announcement`);
      if (response.ok) {
        const data = await response.json();
        setAnnouncement(data);
      }
    } catch (error) {
      console.error('Error fetching announcement:', error);
    }
  };

  const saveAnnouncement = async () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/monitoring/announcement`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ message: announcementInput, is_active: true })
      });

      if (response.ok) {
        toast.success('Announcement updated successfully!');
        setShowAnnouncementModal(false);
        fetchAnnouncement();
      } else {
        const error = await response.json();
        toast.error(error.detail || 'Failed to update announcement');
      }
    } catch (error) {
      console.error('Error saving announcement:', error);
      toast.error('Error saving announcement');
    }
  };

  const deleteAnnouncement = async () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/monitoring/announcement`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        toast.success('Announcement removed successfully!');
        setShowAnnouncementModal(false);
        fetchAnnouncement();
      }
    } catch (error) {
      console.error('Error deleting announcement:', error);
      toast.error('Error deleting announcement');
    }
  };

  const handleProfilePhotoUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Validate file size (max 2MB)
    if (file.size > 2 * 1024 * 1024) {
      toast.error('Image size should be less than 2MB');
      return;
    }

    // Validate file type
    if (!file.type.startsWith('image/')) {
      toast.error('Please upload an image file');
      return;
    }

    try {
      // Convert to base64
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64Image = reader.result;
        
        // Upload to backend
        const token = localStorage.getItem('monitoringAdminToken');
        const response = await fetch(`${API_URL}/api/monitoring/profile/photo`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({ profilePhoto: base64Image })
        });

        if (response.ok) {
          const data = await response.json();
          setProfilePhoto(data.profilePhoto);
          toast.success('Profile photo updated successfully!');
        } else {
          toast.error('Failed to upload profile photo');
        }
      };
      reader.readAsDataURL(file);
    } catch (error) {
      console.error('Error uploading profile photo:', error);
      toast.error('Error uploading profile photo');
    }
  };

  const fetchCustomers = async (silent = false) => {
    if (!silent) setLoading(true);
    const token = localStorage.getItem('monitoringAdminToken');
    if (!token) {
      navigate('/monitoring-dashboard/login');
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/customer-monitoring/status`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setCustomers(data);
      }
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = async () => {
    setRefreshing(true);
    const token = localStorage.getItem('monitoringAdminToken');
    try {
      await fetch(`${API_URL}/api/customer-monitoring/ping-all`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      toast.success('Refreshing status...');
      setTimeout(() => {
        fetchCustomers(true);
        setRefreshing(false);
      }, 3000);
    } catch (error) {
      toast.error('Failed to refresh');
      setRefreshing(false);
    }
  };

  const handleSaveCustomer = async () => {
    const token = localStorage.getItem('monitoringAdminToken');
    
    // Validate required fields
    if (!formData.customer_name || !formData.office_name || !formData.static_ip || !formData.city || !formData.state) {
      toast.error('Please fill all required fields (marked with *)');
      return;
    }
    
    setLoading(true);
    try {
      const url = editingCustomer
        ? `${API_URL}/api/customer-monitoring/customers/${editingCustomer.id}`
        : `${API_URL}/api/customer-monitoring/customers`;
      const method = editingCustomer ? 'PUT' : 'POST';
      
      // Prepare data with proper types - including circuit_id and backend_partner
      const submitData = {
        customer_name: formData.customer_name,
        office_name: formData.office_name,
        static_ip: formData.static_ip,
        circuit_id: formData.circuit_id || '',
        backend_partner: formData.backend_partner || 'Netix',
        city: formData.city,
        state: formData.state,
        email: formData.email || '',
        is_suspended: formData.is_suspended || false,
        isp: formData.isp || 'Netix',
        managed_by: formData.managed_by || 'Netix',
        service: formData.service || 'Lease Line',
        broadband_account_number: formData.broadband_account_number || '',
        last_recharge_date: formData.last_recharge_date || '',
        last_recharge_amount: formData.last_recharge_amount !== '' && formData.last_recharge_amount !== null ? parseFloat(formData.last_recharge_amount) : null,
        plan_speed: formData.plan_speed || '',
        plan_duration_months: formData.plan_duration_months ? parseInt(formData.plan_duration_months) : null,
        router_name: formData.router_name || '',
        router_model: formData.router_model || '',
        router_ip: formData.router_ip || '',
        router_username: formData.router_username || '',
        router_password: formData.router_password || ''
      };
      
      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(submitData)
      });
      
      if (response.ok) {
        const savedCustomer = await response.json();
        
        // If router credentials are provided, save them separately (encrypted on backend)
        if (formData.router_password && (formData.router_name || formData.router_ip)) {
          const customerId = editingCustomer ? editingCustomer.id : savedCustomer.id;
          try {
            await fetch(`${API_URL}/api/customers/${customerId}/router`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
              },
              body: JSON.stringify({
                router_name: formData.router_name || '',
                router_model: formData.router_model || '',
                router_ip: formData.router_ip || '',
                router_username: formData.router_username || '',
                router_password: formData.router_password || ''
              })
            });
          } catch (routerError) {
            console.error('Error saving router info:', routerError);
            toast.warning('Customer saved, but router credentials may not have been updated');
          }
        }
        
        toast.success(editingCustomer ? 'Updated!' : 'Added!');
        setShowAddModal(false);
        setEditingCustomer(null);
        setFormData({
          customer_name: '',
          office_name: '',
          static_ip: '',
          circuit_id: '',
          backend_partner: 'Netix',
          city: '',
          state: '',
          email: '',
          is_suspended: false,
          isp: 'Netix',
          managed_by: 'Netix',
          service: 'Lease Line',
          broadband_account_number: '',
          last_recharge_date: '',
          last_recharge_amount: '',
          plan_speed: '',
          plan_duration_months: '',
          router_name: '',
          router_model: '',
          router_ip: '',
          router_username: '',
          router_password: ''
        });
        fetchCustomers();
      } else {
        // Handle error response
        const errorData = await response.json().catch(() => ({}));
        toast.error(errorData.detail || `Failed to ${editingCustomer ? 'update' : 'add'} customer`);
      }
    } catch (error) {
      console.error('Error saving customer:', error);
      toast.error(`Error: ${error.message || 'Failed to save'}`);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadCustomerData = async () => {
    const token = localStorage.getItem('monitoringAdminToken');
    try {
      toast.info('Preparing Excel file...');
      const response = await fetch(`${API_URL}/api/customer-monitoring/export-excel`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (!response.ok) {
        const err = await response.json().catch(() => ({}));
        toast.error(err.detail || 'Failed to download customer data');
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `netix_customers_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Customer data downloaded!');
    } catch (error) {
      console.error('Error downloading customer data:', error);
      toast.error('Failed to download customer data');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this customer?')) return;
    const token = localStorage.getItem('monitoringAdminToken');
    try {
      await fetch(`${API_URL}/api/customer-monitoring/customers/${id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      toast.success('Deleted!');
      fetchCustomers();
    } catch (error) {
      toast.error('Failed to delete');
    }
  };

  const editCustomer = (customer) => {
    setEditingCustomer(customer);
    setFormData({
      customer_name: customer.customer_name,
      office_name: customer.office_name,
      static_ip: customer.static_ip,
      circuit_id: customer.circuit_id || '',
      backend_partner: customer.backend_partner || 'Netix',
      city: customer.city,
      state: customer.state,
      email: customer.email || '',
      is_suspended: customer.is_suspended || false,
      isp: customer.isp || 'Netix',
      managed_by: customer.managed_by || 'Netix',
      service: customer.service || 'Lease Line',
      broadband_account_number: customer.broadband_account_number || '',
      last_recharge_date: customer.last_recharge_date || '',
      last_recharge_amount: customer.last_recharge_amount ?? '',
      plan_speed: customer.plan_speed || '',
      plan_duration_months: customer.plan_duration_months ?? '',
      router_name: customer.router_name || '',
      router_model: customer.router_model || '',
      router_ip: customer.router_ip || '',
      router_username: customer.router_username || '',
      router_password: '', // Don't show existing password for security
      ticket_approved: customer.ticket_approved || false
    });
    setShowAddModal(true);
  };

  // Router Login Handler
  const handleRouterLogin = async (customer) => {
    if (!customer.router_ip) {
      toast.error('No router IP configured for this customer');
      return;
    }

    setLoadingRouter(true);
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/customers/${customer.id}/router`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch router credentials');
      }

      const credentials = await response.json();
      
      if (!credentials.router_username || !credentials.router_password) {
        toast.error('Router credentials not configured for this customer');
        setLoadingRouter(false);
        return;
      }

      // Open router IP in new tab
      const routerUrl = credentials.router_ip.startsWith('http') 
        ? credentials.router_ip 
        : `http://${credentials.router_ip}`;
      window.open(routerUrl, '_blank');

      // Show copy-paste helper modal
      setRouterCredentials({
        ...credentials,
        customer_name: customer.customer_name,
        customer_id: customer.id
      });
      setShowRouterModal(true);

      // Log the access attempt
      await fetch(`${API_URL}/api/router/access-log`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          customer_id: customer.id,
          customer_name: customer.customer_name,
          router_ip: credentials.router_ip,
          success: true
        })
      });

      toast.success('Router credentials loaded. Use the copy buttons to paste into the login form.');
    } catch (error) {
      console.error('Error loading router credentials:', error);
      toast.error('Failed to load router credentials');
    } finally {
      setLoadingRouter(false);
    }
  };

  // Copy to clipboard handler
  const handleCopyToClipboard = async (text, field) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopiedField(field);
      toast.success(`${field} copied to clipboard!`);
      setTimeout(() => setCopiedField(null), 2000);
    } catch (error) {
      console.error('Failed to copy:', error);
      toast.error('Failed to copy to clipboard');
    }
  };

  // Router Control Functions
  const fetchRouterMockMode = async () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/router-control/mock-mode`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setRouterMockMode(data.mock_mode);
      }
    } catch (error) {
      console.error('Error fetching mock mode:', error);
    }
  };

  const toggleRouterMockMode = async () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const newMode = !routerMockMode;
      const response = await fetch(`${API_URL}/api/router-control/mock-mode?enabled=${newMode}`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        setRouterMockMode(newMode);
        toast.success(`Router control mode: ${newMode ? 'MOCK' : 'REAL'}`);
      } else {
        toast.error('Failed to toggle router mode');
      }
    } catch (error) {
      console.error('Error toggling mock mode:', error);
      toast.error('Failed to toggle router mode');
    }
  };

  const handleRebootRouter = (customer) => {
    setSelectedRouterCustomer(customer);
    setConfirmAction({
      type: 'reboot',
      title: 'Reboot Router',
      message: `Are you sure you want to reboot the router for ${customer.customer_name}? This will temporarily disconnect their internet.`,
      action: () => executeRebootRouter(customer.id)
    });
    setShowConfirmDialog(true);
  };

  const executeRebootRouter = async (customerId) => {
    setRouterActionInProgress(true);
    setShowConfirmDialog(false);
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/router-control/reboot/${customerId}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      
      if (data.success) {
        toast.success(data.message);
      } else {
        toast.error(data.message || 'Failed to reboot router');
      }
    } catch (error) {
      console.error('Error rebooting router:', error);
      toast.error('Failed to reboot router');
    } finally {
      setRouterActionInProgress(false);
      setSelectedRouterCustomer(null);
    }
  };

  const handleWANControl = (customer, action) => {
    setSelectedRouterCustomer(customer);
    const actionText = action === 'enable' ? 'Enable' : 'Disable';
    setConfirmAction({
      type: `wan_${action}`,
      title: `${actionText} Internet`,
      message: `Are you sure you want to ${action} internet for ${customer.customer_name}?`,
      action: () => executeWANControl(customer.id, action)
    });
    setShowConfirmDialog(true);
  };

  const executeWANControl = async (customerId, action) => {
    setRouterActionInProgress(true);
    setShowConfirmDialog(false);
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/router-control/wan/${customerId}/${action}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      
      if (data.success) {
        toast.success(data.message);
      } else {
        toast.error(data.message || `Failed to ${action} WAN`);
      }
    } catch (error) {
      console.error(`Error ${action}ing WAN:`, error);
      toast.error(`Failed to ${action} internet`);
    } finally {
      setRouterActionInProgress(false);
      setSelectedRouterCustomer(null);
    }
  };

  const handleFetchRouterLogs = async (customer) => {
    setSelectedRouterCustomer(customer);
    setShowRouterLogsModal(true);
    setRouterLogs('Loading logs...');
    
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/router-control/logs/${customer.id}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await response.json();
      
      if (data.success) {
        setRouterLogs(data.logs);
      } else {
        setRouterLogs(`Error: ${data.message}`);
      }
    } catch (error) {
      console.error('Error fetching logs:', error);
      setRouterLogs('Error: Failed to fetch router logs');
    }
  };

  const openRouterControlPanel = (customer) => {
    setSelectedRouterCustomer(customer);
    setShowRouterControlModal(true);
  };

  // Ticket System Functions
  const fetchTickets = async () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const userEmail = currentUser?.email || '';
      
      // Sub-users only see their own tickets
      const params = userPermissions.can_manage_users 
        ? '?limit=5' 
        : `?limit=50&search=${encodeURIComponent(userEmail)}`;
      
      const response = await fetch(`${API_URL}/api/smart-tickets${params}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        
        // For sub-users, filter to show only tickets they created
        if (!userPermissions.can_manage_users) {
          const myTickets = data.filter(t => t.created_by === userEmail);
          setTickets(myTickets);
        } else {
          setTickets(data);
        }
      }
    } catch (error) {
      console.error('Error fetching tickets:', error);
    }
  };

  const fetchTicketStats = async () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/smart-tickets/stats`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setTicketStats(data);
      }
    } catch (error) {
      console.error('Error fetching ticket stats:', error);
    }
  };

  const handleLogTicket = async () => {
    if (!ticketFormData.customer_id || !ticketFormData.subject || !ticketFormData.description) {
      toast.error('Please fill in all required fields');
      return;
    }

    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/smart-tickets`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(ticketFormData)
      });

      if (response.ok) {
        toast.success('Ticket created successfully!');
        setShowLogTicketModal(false);
        setTicketFormData({
          customer_id: '',
          customer_name: '',
          category: 'Technical',
          priority: 'Medium',
          subject: '',
          description: '',
          customer_ip: ''
        });
        fetchTickets();
        fetchTicketStats();
      } else {
        toast.error('Failed to create ticket');
      }
    } catch (error) {
      console.error('Error creating ticket:', error);
      toast.error('Failed to create ticket');
    }
  };

  const openTicketDetail = async (ticket) => {
    setSelectedTicket(ticket);
    setShowTicketDetailModal(true);
    
    // Fetch replies
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/smart-tickets/${ticket.ticket_id}/replies`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (response.ok) {
        const data = await response.json();
        setTicketReplies(data);
      }
    } catch (error) {
      console.error('Error fetching replies:', error);
    }
  };

  const handleSendReply = async () => {
    if (!replyMessage.trim()) {
      toast.error('Please enter a message');
      return;
    }

    setSendingReply(true);
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/smart-tickets/${selectedTicket.ticket_id}/reply`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          message: replyMessage,
          is_internal: false
        })
      });

      if (response.ok) {
        toast.success('Reply sent!');
        setReplyMessage('');
        openTicketDetail(selectedTicket);
        fetchTickets();
      } else {
        toast.error('Failed to send reply');
      }
    } catch (error) {
      console.error('Error sending reply:', error);
      toast.error('Failed to send reply');
    } finally {
      setSendingReply(false);
    }
  };

  const handleUpdateTicketStatus = async (ticketId, newStatus) => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/smart-tickets/${ticketId}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ status: newStatus })
      });

      if (response.ok) {
        toast.success('Status updated!');
        setShowTicketDetailModal(false);
        fetchTickets();
        fetchTicketStats();
      } else {
        toast.error('Failed to update status');
      }
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('Failed to update status');
    }
  };

  // getMarkerIcon function removed

  // Helper function to parse UTC timestamp from backend
  // Backend returns timestamps like "2026-01-29T16:51:09.727000" without timezone
  // These are stored in UTC, so we need to treat them as UTC
  const parseUTCTimestamp = (timestamp) => {
    if (!timestamp) return null;
    // If timestamp doesn't have timezone info, append 'Z' to treat as UTC
    const ts = timestamp.endsWith('Z') || timestamp.includes('+') || timestamp.includes('-', 10) 
      ? timestamp 
      : timestamp + 'Z';
    return new Date(ts);
  };

  const formatActiveSince = (activeSince) => {
    if (!activeSince) return 'N/A';
    
    try {
      const now = Date.now();
      const utcDate = parseUTCTimestamp(activeSince);
      if (!utcDate || isNaN(utcDate.getTime())) return 'Invalid time';
      
      const then = utcDate.getTime();
      const diff = now - then;
      
      // Handle negative time (future dates - shouldn't happen but safety check)
      if (diff < 0) {
        return 'Just now';
      }
      
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      
      if (days > 0) {
        return `${days}d ${hours}h`;
      } else if (hours > 0) {
        return `${hours}h ${minutes}m`;
      } else if (minutes > 0) {
        return `${minutes}m`;
      } else {
        return 'Just now';
      }
    } catch (error) {
      console.error('Error formatting time:', error, activeSince);
      return 'Invalid time';
    }
  };

  // Format date to show "since when" - e.g., "Feb 15, 2:30 PM" in user's local timezone
  // Format date to show "since when" - always shows: "DD Mon, HH:MM am/pm" format
  const formatSinceWhen = (timestamp) => {
    if (!timestamp) return 'N/A';
    try {
      // Parse UTC timestamp and convert to local time for display
      const utcDate = parseUTCTimestamp(timestamp);
      if (!utcDate || isNaN(utcDate.getTime())) return 'Invalid';
      
      // Always show consistent format: "27 Feb, 07:12 pm"
      const dateStr = utcDate.toLocaleDateString('en-IN', { 
        day: 'numeric',
        month: 'short'
      });
      const timeStr = utcDate.toLocaleTimeString('en-IN', { 
        hour: '2-digit', 
        minute: '2-digit',
        hour12: true 
      });
      return `${dateStr}, ${timeStr}`;
    } catch (error) {
      console.error('Error formatting since when:', error, timestamp);
      return 'Invalid';
    }
  };

  // Format full timestamp for tooltip - shows complete date, time and duration
  const getRechargeStatus = (customer) => {
    if (!['Broadband', 'Enterprise Broadband'].includes(customer.service)) return null;
    if (!customer.last_recharge_date) return null;
    const start = new Date(customer.last_recharge_date);
    if (isNaN(start.getTime())) return null;
    const months = parseInt(customer.plan_duration_months) || 1;
    const expiry = new Date(start);
    expiry.setMonth(expiry.getMonth() + months);
    const daysLeft = Math.ceil((expiry.getTime() - Date.now()) / 86400000);
    const dueDate = expiry.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
    const totalDays = Math.round((expiry.getTime() - start.getTime()) / 86400000);
    const activeDays = Math.min(totalDays, Math.max(0, Math.floor((Date.now() - start.getTime()) / 86400000)));
    const base = { daysLeft, dueDate, totalDays, activeDays };
    if (daysLeft > 5) return { ...base, label: `Active · ${daysLeft}d left`, cls: 'bg-green-100 text-green-700 border-green-300', dot: 'bg-green-500', headerBadge: 'bg-white text-green-700' };
    if (daysLeft > 3) return { ...base, label: `Due Soon · ${daysLeft}d left`, cls: 'bg-yellow-100 text-yellow-700 border-yellow-400', dot: 'bg-yellow-500', headerBadge: 'bg-white text-yellow-700' };
    if (daysLeft >= 0) return { ...base, label: daysLeft === 0 ? 'Expires Today' : `Expiring · ${daysLeft}d left`, cls: 'bg-red-100 text-red-700 border-red-400', dot: 'bg-red-500', headerBadge: 'bg-white text-red-700' };
    return { ...base, label: `Expired ${Math.abs(daysLeft)}d ago`, cls: 'bg-red-100 text-red-700 border-red-400', dot: 'bg-red-500', headerBadge: 'bg-white text-red-700' };
  };

  const formatFullTimestamp = (timestamp) => {
    if (!timestamp) return 'Not available';
    try {
      const utcDate = parseUTCTimestamp(timestamp);
      if (!utcDate || isNaN(utcDate.getTime())) return 'Invalid timestamp';
      
      const now = new Date();
      const diff = now - utcDate;
      
      // Calculate duration
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      
      // Format full date and time
      const fullDateTime = utcDate.toLocaleString('en-IN', {
        weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
      
      // Format duration string
      let durationStr = '';
      if (days > 0) {
        durationStr = `${days} day${days > 1 ? 's' : ''}, ${hours} hr${hours > 1 ? 's' : ''}, ${minutes} min`;
      } else if (hours > 0) {
        durationStr = `${hours} hr${hours > 1 ? 's' : ''}, ${minutes} min`;
      } else {
        durationStr = `${minutes} min`;
      }
      
      return `${fullDateTime}\n(${durationStr} ago)`;
    } catch (error) {
      return 'Error formatting timestamp';
    }
  };

  const stats = {
    total: customers.length,
    active: customers.filter(c => c.status === 'active').length,
    inactive: customers.filter(c => c.status === 'inactive').length,
    suspended: customers.filter(c => c.status === 'suspended').length
  };

  // Get user info for welcome message
  const getUserInfo = () => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      if (!token) return null;
      
      // Decode JWT token
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(window.atob(base64));
      
      if (payload.user_type === 'admin') {
        return { name: 'Admin', email: payload.sub, role: 'Administrator', profilePhoto };
      } else {
        // Sub-user
        const userInfo = localStorage.getItem('monitoringUser');
        if (userInfo) {
          const user = JSON.parse(userInfo);
          return { name: user.username, email: user.email, role: user.role, profilePhoto };
        }
        return { name: payload.sub, email: payload.email, role: payload.role || 'User', profilePhoto };
      }
    } catch (error) {
      return null;
    }
  };

  const currentUser = getUserInfo();

  const handleRequestFeatureAccess = async (featureName, featureKey) => {
    try {
      const token = localStorage.getItem('monitoringAdminToken');
      const response = await fetch(`${API_URL}/api/monitoring-users/feature-requests`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          feature_name: featureName,
          feature_key: featureKey,
          reason: `I would like to access ${featureName} to better assist with monitoring tasks.`
        })
      });

      if (response.ok) {
        toast.success('Feature access request submitted! Admin will review it soon.');
      } else {
        const data = await response.json();
        toast.error(data.detail || 'Failed to submit request');
      }
    } catch (error) {
      console.error('Error requesting feature access:', error);
      toast.error('Error submitting request');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 relative z-0">
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        @keyframes running {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(400%); }
        }
        @keyframes heartbeat {
          0%, 100% { transform: scaleY(1); }
          25% { transform: scaleY(1.2); }
          50% { transform: scaleY(0.8); }
          75% { transform: scaleY(1.1); }
        }
        @keyframes wave {
          0%, 100% { d: path("M0,20 Q25,10 50,20 T100,20 T150,20 T200,20"); }
          50% { d: path("M0,20 Q25,30 50,20 T100,20 T150,20 T200,20"); }
        }
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        @keyframes slide {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(500%); }
        }
      `}</style>
      {/* Compact Header */}
      {isIndependenceThemeActive() && (
        <div className="h-1.5 w-full flex" data-testid="tricolor-strip">
          <div className="flex-1" style={{ background: '#FF9933' }}></div>
          <div className="flex-1 bg-white"></div>
          <div className="flex-1" style={{ background: '#138808' }}></div>
        </div>
      )}
      <div
        className={`text-white shadow-lg ${isIndependenceThemeActive() ? '' : 'bg-gradient-to-r from-blue-600 to-indigo-700'}`}
        style={isIndependenceThemeActive() ? { background: 'linear-gradient(90deg, #c2410c 0%, #1e40af 38%, #1e3a8a 62%, #15803d 100%)' } : undefined}
      >
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => {
                  localStorage.removeItem('monitoringAdminToken');
                  navigate('/monitoring-dashboard/login');
                }}
                className="text-white hover:bg-white/20"
              >
                <ArrowLeft className="h-4 w-4 mr-1" />
                Logout
              </Button>
              <div className="h-8 w-px bg-white/30"></div>
              <Activity className="h-5 w-5" />
              <h1 className="text-xl font-bold">Netix Customer IP Monitoring</h1>
              <div className="hidden md:flex items-center gap-4 ml-4">
                {/* LIVE Mode Indicator - Enhanced Brightness */}
                <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-sm font-bold shadow-lg ${
                  liveMode ? 'bg-gradient-to-r from-red-500 to-red-600 animate-pulse shadow-red-500/50' : 'bg-white/10'
                }`}>
                  <div className={`w-3 h-3 rounded-full ${liveMode ? 'bg-white animate-ping shadow-lg shadow-white/80' : 'bg-gray-400'}`}></div>
                  <span className={liveMode ? 'text-white' : ''}>{liveMode ? 'LIVE' : 'PAUSED'}</span>
                </div>
                
                <div className="flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full text-sm">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span>{stats.active} Active</span>
                </div>
                <div className="flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full text-sm">
                  <div className="w-2 h-2 bg-red-400 rounded-full"></div>
                  <span>{stats.inactive} Inactive</span>
                </div>
                {stats.suspended > 0 && (
                  <div className="flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full text-sm">
                    <div className="w-2 h-2 bg-orange-400 rounded-full"></div>
                    <span>{stats.suspended} Suspended</span>
                  </div>
                )}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="text-xs text-white/80 mr-2 hidden lg:flex flex-col items-end">
                <div>Updated: {lastUpdate.toLocaleTimeString()}</div>
                {liveMode && <div className="text-green-300">Next: {nextRefresh}s</div>}
              </div>
              <Button
                onClick={() => setLiveMode(!liveMode)}
                size="sm"
                className={`${liveMode ? 'bg-red-500 hover:bg-red-600' : 'bg-white/20 hover:bg-white/30'} text-white`}
              >
                {liveMode ? '⏸ Pause' : '▶ Resume'}
              </Button>
              <Button
                onClick={handleRefresh}
                disabled={refreshing}
                size="sm"
                className="bg-white text-blue-600 hover:bg-blue-50"
              >
                <RefreshCw className={`h-4 w-4 mr-1 ${refreshing ? 'animate-spin' : ''}`} />
                Refresh
              </Button>
              {userPermissions.can_manage_users && (
                <Button
                  onClick={() => navigate('/monitoring-dashboard/users')}
                  size="sm"
                  className="bg-purple-500 text-white hover:bg-purple-600"
                >
                  <Users className="h-4 w-4 mr-1" />
                  Users
                </Button>
              )}
              {userPermissions.can_add_customer && (
                <Button
                  onClick={() => {
                    setEditingCustomer(null);
                    setFormData({
                      customer_name: '',
                      office_name: '',
                      static_ip: '',
                      city: '',
                      state: '',
                      is_suspended: false
                    });
                    setShowAddModal(true);
                  }}
                  size="sm"
                  className="bg-white text-blue-600 hover:bg-blue-50"
                >
                  <Plus className="h-4 w-4 mr-1" />
                  Add
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* 3D floating Tricolour wave background (auto-off after 20 Aug 2026) */}
      <TricolorWaveBackground />

      <div className="max-w-7xl mx-auto px-4 py-4">
        {/* Welcome Message */}
        {currentUser && (
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4 mb-4 shadow-sm">
            <div className="flex items-center justify-between gap-4">
              <div className="flex items-center gap-4">
                {/* Netix Logo */}
                <div className="bg-white rounded-lg p-2 shadow-md">
                  <img 
                    src="/netix-logo-horizontal.png" 
                    alt="Netix Fibernet" 
                    className="h-12 w-auto object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900">Welcome, {currentUser.name}!</h3>
                  <p className="text-sm text-gray-600">Role: <span className="font-semibold text-blue-600">{currentUser.role}</span></p>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                {/* Live Network Health - Animated Card (Both Admin & Sub-users) */}
                <div className="relative bg-gradient-to-br from-green-400 via-emerald-500 to-green-600 rounded-lg px-3 py-1.5 shadow-lg overflow-hidden group hover:shadow-xl transition-shadow">
                  {/* Animated heartbeat line */}
                  <div className="absolute inset-0 opacity-20">
                    <svg className="w-full h-full" viewBox="0 0 200 40" preserveAspectRatio="none">
                      <path d="M0,20 L50,20 L55,10 L60,30 L65,20 L200,20" stroke="white" strokeWidth="2" fill="none" className="animate-[heartbeat_2s_ease-in-out_infinite]" />
                    </svg>
                  </div>
                  {/* Running light effect */}
                  <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-30 animate-[shimmer_3s_ease-in-out_infinite]"></div>
                  <div className="flex items-center justify-between gap-2 relative z-10">
                    <div className="flex items-center gap-2">
                      {/* Blinking heart */}
                      <div className="relative">
                        <svg className="h-4 w-4 text-white animate-pulse" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
                        </svg>
                        <div className="absolute -top-1 -right-1 w-2 h-2 bg-red-400 rounded-full animate-ping"></div>
                      </div>
                      <div>
                        <p className="text-xs text-white font-semibold leading-tight flex items-center gap-1">
                          Live Health
                          <span className="inline-block w-1 h-1 bg-white rounded-full animate-pulse"></span>
                        </p>
                        <p className="text-lg font-black text-white leading-tight tracking-wide">
                          {Math.round((stats.active / stats.total) * 100) || 0}%
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Network Uptime - Animated Card (Both Admin & Sub-users) */}
                <div className="relative bg-gradient-to-br from-blue-500 via-indigo-600 to-purple-600 rounded-lg px-3 py-1.5 shadow-lg overflow-hidden group hover:shadow-xl transition-shadow">
                  {/* Animated wave line */}
                  <div className="absolute inset-0 opacity-20">
                    <svg className="w-full h-full" viewBox="0 0 200 40" preserveAspectRatio="none">
                      <path d="M0,20 Q25,10 50,20 T100,20 T150,20 T200,20" stroke="white" strokeWidth="2" fill="none" className="animate-[wave_4s_ease-in-out_infinite]" />
                    </svg>
                  </div>
                  {/* Running light */}
                  <div className="absolute top-0 left-0 w-20 h-full bg-gradient-to-r from-transparent via-white to-transparent opacity-30 animate-[slide_3s_linear_infinite]"></div>
                  <div className="flex items-center justify-between gap-2 relative z-10">
                    <div className="flex items-center gap-2">
                      {/* Blinking signal icon */}
                      <div className="relative">
                        <Activity className="h-4 w-4 text-white animate-pulse" />
                        <div className="absolute -top-0.5 -right-0.5 w-2 h-2">
                          <div className="w-full h-full bg-yellow-300 rounded-full animate-ping"></div>
                          <div className="absolute inset-0 w-full h-full bg-yellow-400 rounded-full"></div>
                        </div>
                      </div>
                      <div>
                        <p className="text-xs text-white font-semibold leading-tight flex items-center gap-1">
                          Network Uptime
                          <span className="inline-block w-1 h-1 bg-yellow-300 rounded-full animate-pulse"></span>
                        </p>
                        <p className="text-lg font-black text-white leading-tight tracking-wide">
                          {networkUptime > 99 ? networkUptime.toFixed(2) : networkUptime.toFixed(1)}%
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Sub-user Place New Request Button - Moved after Network Uptime */}
                {!userPermissions.can_manage_users && (
                    <Button
                      onClick={() => window.open('https://netixfibernet.com/request-service', '_blank')}
                      size="sm"
                      className="bg-green-500 text-white hover:bg-green-600 flex items-center gap-2"
                    >
                      <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                      Place New Request
                    </Button>
                )}
                
                {/* Log Ticket Button (For all users) - After Place New Request */}
                <Button
                  onClick={() => setShowLogTicketModal(true)}
                  size="sm"
                  className="bg-gradient-to-r from-orange-500 to-red-500 text-white hover:from-orange-600 hover:to-red-600 flex items-center gap-2 shadow-lg"
                >
                  <Ticket className="h-4 w-4" />
                  Log Ticket
                </Button>
                
                {/* Admin-only Buttons */}
                {userPermissions.can_manage_users && (
                  <>
                    <Button
                      onClick={() => navigate('/monitoring-dashboard/feature-requests')}
                      size="sm"
                      className="bg-purple-500 text-white hover:bg-purple-600"
                    >
                      <Shield className="h-4 w-4 mr-1" />
                      Requests
                    </Button>
                    
                    <Button
                      onClick={() => navigate('/monitoring-dashboard/escalation-settings')}
                      size="sm"
                      className="bg-indigo-500 text-white hover:bg-indigo-600"
                    >
                      <Shield className="h-4 w-4 mr-1" />
                      Escalation Workflow
                    </Button>
                  </>
                )}
                
                {/* Internal Chat */}
                <InternalChat />
                
                {/* Profile Photo Section */}
                <div className="relative group">
                <div 
                  className="w-16 h-16 rounded-full overflow-hidden border-2 border-blue-300 shadow-md cursor-pointer hover:border-blue-500 transition-all"
                  onClick={() => document.getElementById('profilePhotoInput').click()}
                >
                  {currentUser.profilePhoto ? (
                    <img 
                      src={currentUser.profilePhoto} 
                      alt="Profile" 
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full bg-gradient-to-br from-blue-400 to-indigo-500 flex items-center justify-center text-white text-xl font-bold">
                      {currentUser.name?.charAt(0).toUpperCase()}
                    </div>
                  )}
                </div>
                <div className="absolute -bottom-1 -right-1 bg-blue-500 text-white rounded-full p-1 cursor-pointer hover:bg-blue-600 shadow-lg">
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <input
                  type="file"
                  id="profilePhotoInput"
                  accept="image/*"
                  className="hidden"
                  onChange={handleProfilePhotoUpload}
                />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Enhanced Announcement Banner - Medium Size with New Theme & Dynamic Graphics */}
        {announcement.is_active && announcement.message && (
          <div className="mb-4 relative overflow-hidden rounded-xl shadow-2xl border-2 border-cyan-400 group">
            {/* Dynamic Multi-Layer Gradient Background - Blue/Cyan/Purple Theme */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500 via-cyan-400 via-purple-500 via-pink-500 to-blue-500 animate-gradient-xy bg-[length:400%_400%]"></div>
            
            {/* Radial glow effect */}
            <div className="absolute inset-0 opacity-30">
              <div className="absolute top-0 left-1/4 w-32 h-32 bg-cyan-300 rounded-full blur-3xl animate-pulse-slow"></div>
              <div className="absolute top-0 right-1/4 w-32 h-32 bg-purple-300 rounded-full blur-3xl animate-pulse-slow" style={{ animationDelay: '1s' }}></div>
            </div>
            
            {/* Dynamic Floating Particles - More Count */}
            <div className="absolute inset-0 opacity-50">
              {/* Row 1 - Top particles */}
              <div className="absolute top-2 left-[8%] w-1.5 h-1.5 bg-white rounded-full animate-float"></div>
              <div className="absolute top-3 left-[18%] w-2 h-2 bg-cyan-200 rounded-full animate-float-reverse" style={{ animationDelay: '0.2s' }}></div>
              <div className="absolute top-2 left-[28%] w-1 h-1 bg-white rounded-full animate-float" style={{ animationDelay: '0.4s' }}></div>
              <div className="absolute top-4 left-[38%] w-1.5 h-1.5 bg-purple-200 rounded-full animate-float-reverse" style={{ animationDelay: '0.6s' }}></div>
              <div className="absolute top-2 left-[48%] w-2 h-2 bg-white rounded-full animate-float" style={{ animationDelay: '0.8s' }}></div>
              <div className="absolute top-3 left-[58%] w-1 h-1 bg-cyan-200 rounded-full animate-float-reverse" style={{ animationDelay: '1s' }}></div>
              <div className="absolute top-2 left-[68%] w-1.5 h-1.5 bg-white rounded-full animate-float" style={{ animationDelay: '1.2s' }}></div>
              <div className="absolute top-4 left-[78%] w-2 h-2 bg-purple-200 rounded-full animate-float-reverse" style={{ animationDelay: '1.4s' }}></div>
              <div className="absolute top-2 left-[88%] w-1 h-1 bg-white rounded-full animate-float" style={{ animationDelay: '1.6s' }}></div>
              
              {/* Row 2 - Bottom particles */}
              <div className="absolute bottom-2 left-[12%] w-1 h-1 bg-cyan-300 rounded-full animate-ping-slow"></div>
              <div className="absolute bottom-3 left-[25%] w-1.5 h-1.5 bg-white rounded-full animate-ping-slow" style={{ animationDelay: '0.3s' }}></div>
              <div className="absolute bottom-2 left-[40%] w-1 h-1 bg-purple-300 rounded-full animate-ping-slow" style={{ animationDelay: '0.6s' }}></div>
              <div className="absolute bottom-3 left-[55%] w-1.5 h-1.5 bg-cyan-300 rounded-full animate-ping-slow" style={{ animationDelay: '0.9s' }}></div>
              <div className="absolute bottom-2 left-[70%] w-1 h-1 bg-white rounded-full animate-ping-slow" style={{ animationDelay: '1.2s' }}></div>
              <div className="absolute bottom-3 left-[85%] w-1.5 h-1.5 bg-purple-300 rounded-full animate-ping-slow" style={{ animationDelay: '1.5s' }}></div>
            </div>
            
            {/* Multiple Wave Animations */}
            <div className="absolute inset-0 opacity-20">
              <div className="absolute inset-0 animate-wave bg-gradient-to-r from-transparent via-white to-transparent"></div>
              <div className="absolute inset-0 animate-wave-reverse bg-gradient-to-r from-transparent via-cyan-200 to-transparent"></div>
            </div>
            
            {/* Sparkle effects */}
            <div className="absolute inset-0 opacity-60">
              <div className="absolute top-1/2 left-[15%] w-2 h-2 animate-sparkle">✨</div>
              <div className="absolute top-1/2 left-[45%] w-2 h-2 animate-sparkle" style={{ animationDelay: '0.5s' }}>✨</div>
              <div className="absolute top-1/2 left-[75%] w-2 h-2 animate-sparkle" style={{ animationDelay: '1s' }}>✨</div>
            </div>
            
            {/* Main content - Medium Size */}
            <div className="relative flex items-center py-3 px-4">
              {/* Enhanced animated icon */}
              <div className="flex-shrink-0 mr-3">
                <div className="relative w-11 h-11">
                  {/* Double pulse rings */}
                  <div className="absolute inset-0 bg-white rounded-full opacity-60 animate-ping-slow"></div>
                  <div className="absolute inset-0 bg-cyan-300 rounded-full opacity-40 animate-ping" style={{ animationDelay: '0.5s' }}></div>
                  {/* Icon container with glow */}
                  <div className="relative bg-gradient-to-br from-white to-cyan-100 rounded-full p-2 shadow-xl">
                    <svg className="w-7 h-7 text-blue-600 animate-bounce-slow" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"/>
                    </svg>
                  </div>
                </div>
              </div>
              
              {/* Badge and scrolling text */}
              <div className="flex-1 overflow-hidden flex items-center gap-3">
                {/* Enhanced badge with glow */}
                <div className="relative flex-shrink-0">
                  <div className="absolute inset-0 bg-white rounded-full blur-sm opacity-50"></div>
                  <span className="relative bg-white/95 backdrop-blur-md px-3.5 py-1.5 rounded-full text-xs font-black shadow-xl border-2 border-cyan-300 flex items-center gap-1.5">
                    <span className="text-xl animate-pulse">📢</span>
                    <span className="bg-gradient-to-r from-blue-600 via-cyan-600 to-purple-600 bg-clip-text text-transparent">LIVE ANNOUNCEMENT</span>
                  </span>
                </div>
                
                {/* Enhanced scrolling text with better styling */}
                <div className="flex-1 overflow-hidden bg-white/20 backdrop-blur-md rounded-lg px-4 py-2 border-2 border-white/40 shadow-inner">
                  <div className="animate-marquee-medium whitespace-nowrap">
                    <span className="text-white font-bold text-base drop-shadow-[0_2px_4px_rgba(0,0,0,0.4)] tracking-wide">
                      ⚡ {announcement.message} ⚡
                    </span>
                  </div>
                </div>
              </div>
              
              {/* Admin controls - Enhanced */}
              {userPermissions.can_manage_users && (
                <div className="flex-shrink-0 ml-3 flex gap-2">
                  <button
                    onClick={() => {
                      setAnnouncementInput(announcement.message);
                      setShowAnnouncementModal(true);
                    }}
                    className="group/btn bg-white/95 backdrop-blur-md text-cyan-600 px-3 py-2 rounded-lg text-sm font-bold hover:bg-white transition-all shadow-lg hover:shadow-xl border-2 border-cyan-300 hover:scale-105"
                  >
                    <Edit className="w-4 h-4" />
                  </button>
                  <button
                    onClick={async () => {
                      try {
                        const token = localStorage.getItem('monitoringAdminToken');
                        await fetch(`${API_URL}/api/monitoring/announcement`, {
                          method: 'POST',
                          headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                          },
                          body: JSON.stringify({ message: '', is_active: false })
                        });
                        setAnnouncement({ message: '', is_active: false });
                        toast.success('Announcement removed!');
                      } catch (error) {
                        toast.error('Failed to remove announcement');
                      }
                    }}
                    className="bg-gradient-to-r from-red-500 to-pink-500 text-white px-3 py-2 rounded-lg text-sm font-bold hover:from-red-600 hover:to-pink-600 transition-all shadow-lg hover:shadow-xl hover:scale-105"
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              )}
              
              {/* Sub-users see enhanced view-only version */}
              {!userPermissions.can_manage_users && (
                <div className="flex-shrink-0 ml-3">
                  <span className="text-white font-semibold text-sm flex items-center gap-2 bg-white/20 backdrop-blur-md px-3 py-2 rounded-lg border-2 border-white/40 shadow-lg">
                    <Clock className="w-4 h-4 animate-pulse" />
                    Live Now
                  </span>
                </div>
              )}
            </div>
            
            {/* Animated multi-color progress bar at bottom */}
            <div className="h-1 bg-gradient-to-r from-blue-400 via-cyan-400 via-purple-400 via-pink-400 to-blue-400 animate-progress bg-[length:300%_100%]"></div>
          </div>
        )}

        {/* Admin: Enhanced Add Announcement Button with New Theme */}
        {userPermissions.can_manage_users && !announcement.is_active && (
          <div className="mb-4">
            <button
              onClick={() => {
                setAnnouncementInput('');
                setShowAnnouncementModal(true);
              }}
              className="group relative w-full bg-gradient-to-r from-blue-50 via-cyan-50 to-purple-50 border-2 border-dashed border-cyan-300 rounded-xl p-4 hover:border-cyan-500 hover:shadow-2xl transition-all duration-300 overflow-hidden"
            >
              {/* Animated background with gradient */}
              <div className="absolute inset-0 bg-gradient-to-r from-blue-400/10 via-cyan-400/10 to-purple-400/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Animated particles */}
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="absolute top-2 left-[15%] w-1 h-1 bg-cyan-400 rounded-full animate-ping"></div>
                <div className="absolute top-3 left-[35%] w-1.5 h-1.5 bg-blue-400 rounded-full animate-ping" style={{ animationDelay: '0.3s' }}></div>
                <div className="absolute top-2 right-[35%] w-1 h-1 bg-purple-400 rounded-full animate-ping" style={{ animationDelay: '0.6s' }}></div>
                <div className="absolute top-3 right-[15%] w-1.5 h-1.5 bg-cyan-400 rounded-full animate-ping" style={{ animationDelay: '0.9s' }}></div>
              </div>
              
              {/* Content */}
              <div className="relative flex items-center justify-center gap-3">
                {/* Enhanced animated icon */}
                <div className="relative">
                  <div className="absolute inset-0 bg-cyan-400 rounded-full blur-lg opacity-30 group-hover:opacity-50 transition-opacity"></div>
                  <div className="relative bg-gradient-to-br from-blue-500 to-cyan-500 rounded-full p-3 shadow-lg group-hover:shadow-2xl transition-all group-hover:scale-110">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                </div>
                
                {/* Enhanced text */}
                <div className="text-left">
                  <span className="block text-lg font-bold bg-gradient-to-r from-blue-600 via-cyan-600 to-purple-600 bg-clip-text text-transparent flex items-center gap-2">
                    📢 Create New Announcement
                  </span>
                  <span className="block text-sm text-gray-600 font-medium">
                    Broadcast important updates to all monitoring users
                  </span>
                </div>
                
                {/* Arrow indicator with animation */}
                <div className="ml-auto">
                  <svg className="w-5 h-5 text-cyan-500 group-hover:translate-x-2 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </button>
          </div>
        )}

        {/* Support Tickets Card removed - now accessible via Ticket Management button */}

        {/* Real-time Inactive Customer Alerts Widget */}
        <div className="mb-4">
          <InactiveCustomerAlerts 
            refreshInterval={30000}
            onViewCustomer={(customerId) => {
              // Find and scroll to the customer card
              const customerCard = document.querySelector(`[data-customer-id="${customerId}"]`);
              if (customerCard) {
                customerCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
                customerCard.classList.add('ring-2', 'ring-red-500', 'ring-offset-2');
                setTimeout(() => {
                  customerCard.classList.remove('ring-2', 'ring-red-500', 'ring-offset-2');
                }, 3000);
              }
            }}
          />
        </div>

        {/* Weather-Based Alerts Widget */}
        <div className="mb-4">
          <WeatherAlerts 
            refreshInterval={300000}
          />
        </div>

        {/* Bandwidth Usage Monitoring Widget */}
        <div className="mb-4">
          <BandwidthMonitoring 
            refreshInterval={30000}
          />
        </div>

        {/* Partner Dashboard */}
        <div className="mb-4">
          <PartnerDashboard 
            refreshInterval={60000}
          />
        </div>

        {/* Network Dashboard Collapsible Section */}
        <div className="mb-4">
          <button
            onClick={() => setShowNetworkDashboard(!showNetworkDashboard)}
            className="w-full bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg p-4 hover:from-blue-600 hover:to-indigo-700 transition-all shadow-md hover:shadow-lg"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Activity className="h-6 w-6" />
                <div className="text-left">
                  <h2 className="text-xl font-bold">Network Dashboard</h2>
                  <p className="text-sm text-blue-100">Advanced monitoring & analytics tools</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {showNetworkDashboard ? (
                  <ChevronUp className="h-6 w-6" />
                ) : (
                  <ChevronDown className="h-6 w-6" />
                )}
              </div>
            </div>
          </button>

          {/* Network Dashboard Cards - Show when expanded */}
          {showNetworkDashboard && (
            <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-4 animate-fadeIn">
          {/* Alert Notification Card */}
          {userPermissions.can_view_alerts && (
            <div 
              onClick={() => navigate('/monitoring-dashboard/alerts')}
              className="bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer hover:border-red-300 relative"
            >
              {/* Netix Logo Badge */}
              <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
                <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-red-100 rounded-full p-3">
                    <Bell className="h-6 w-6 text-red-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Alerts & Notifications</h3>
                    <p className="text-sm text-gray-600">View alert history and recovery notifications</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  className="bg-red-500 text-white hover:bg-red-600"
                >
                  View Alerts →
                </Button>
              </div>
            </div>
          )}

          {/* Ticket Management Card - Admin Only */}
          {userPermissions.can_manage_users && (
            <div 
              onClick={() => navigate('/monitoring-dashboard/tickets')}
              className="bg-gradient-to-r from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer hover:border-blue-300 relative"
            >
              {/* Netix Logo Badge */}
              <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
                <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-blue-100 rounded-full p-3">
                    <Ticket className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Ticket Management</h3>
                    <p className="text-sm text-gray-600">Manage customer support tickets & requests</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  View Tickets →
                </Button>
              </div>
            </div>
          )}

          {/* Router Control Mode Toggle - Admin Only */}
          {userPermissions.can_manage_users && (
            <div 
              className="bg-gradient-to-r from-purple-50 to-pink-50 border-2 border-purple-200 rounded-lg p-4 shadow-sm relative"
            >
              {/* Netix Logo Badge */}
              <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
                <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-purple-100 rounded-full p-3">
                    <Settings className="h-6 w-6 text-purple-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Router Control Mode</h3>
                    <p className="text-sm text-gray-600">Toggle between Mock & Real router control</p>
                  </div>
                </div>
                <div className="flex flex-col items-end gap-2">
                  <div className={`px-3 py-1 rounded-full text-xs font-bold ${routerMockMode ? 'bg-amber-100 text-amber-700' : 'bg-green-100 text-green-700'}`}>
                    {routerMockMode ? 'MOCK MODE' : 'REAL MODE'}
                  </div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      toggleRouterMockMode();
                    }}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2 ${
                      routerMockMode ? 'bg-amber-400' : 'bg-green-500'
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
                        routerMockMode ? 'translate-x-1' : 'translate-x-6'
                      }`}
                    />
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Analytics Card */}
          {userPermissions.can_view_analytics && (
            <div 
              onClick={() => navigate('/monitoring-dashboard/analytics')}
              className="bg-gradient-to-r from-indigo-50 to-purple-50 border-2 border-indigo-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer hover:border-indigo-300 relative"
            >
              {/* Netix Logo Badge */}
              <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
                <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-indigo-100 rounded-full p-3">
                    <Activity className="h-6 w-6 text-indigo-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">Analytics Dashboard</h3>
                    <p className="text-sm text-gray-600">SLA tracking, MTTR metrics, and trends</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  className="bg-indigo-500 text-white hover:bg-indigo-600"
                >
                  View Analytics →
                </Button>
              </div>
            </div>
          )}

          {/* Network Quality Card - Show with request access if no permission */}
          <div 
            onClick={userPermissions.can_view_quality_metrics ? () => navigate('/monitoring-dashboard/quality') : null}
            className={`bg-gradient-to-r from-blue-50 to-cyan-50 border-2 border-blue-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-all ${userPermissions.can_view_quality_metrics ? 'cursor-pointer hover:border-blue-300' : 'opacity-75'} relative`}
          >
            {/* Netix Logo Badge */}
            <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
              <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-blue-100 rounded-full p-3">
                  <Activity className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    Network Quality Metrics
                    {!userPermissions.can_view_quality_metrics && <Shield className="h-4 w-4 text-gray-400" />}
                  </h3>
                  <p className="text-sm text-gray-600">Latency, packet loss, speed & quality scores</p>
                </div>
              </div>
              {userPermissions.can_view_quality_metrics ? (
                <Button
                  size="sm"
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  View Quality →
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('Network Quality Metrics', 'can_view_quality_metrics');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              )}
            </div>
          </div>

          {/* Network Topology Card - Show with request access if no permission */}
          <div 
            onClick={userPermissions.can_view_topology ? () => navigate('/monitoring-dashboard/topology') : null}
            className={`bg-gradient-to-r from-slate-50 to-gray-50 border-2 border-slate-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all ${userPermissions.can_view_topology ? 'cursor-pointer hover:border-slate-400' : 'opacity-75'} relative`}
          >
            {/* Netix Logo Badge */}
            <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
              <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-slate-100 rounded-full p-3">
                  <Activity className="h-6 w-6 text-slate-700" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    Network Topology
                    {!userPermissions.can_view_topology && <Shield className="h-4 w-4 text-gray-400" />}
                  </h3>
                  <p className="text-sm text-gray-600">Visual infrastructure map & impact analysis</p>
                </div>
              </div>
              {userPermissions.can_view_topology ? (
                <Button
                  size="sm"
                  className="bg-slate-600 text-white hover:bg-slate-700"
                >
                  View Map →
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('Network Topology', 'can_view_topology');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              )}
            </div>
          </div>

          {/* Network Diagnostics Card - Show with request access if no permission */}
          <div 
            onClick={userPermissions.can_view_diagnostics ? () => navigate('/monitoring-dashboard/diagnostics') : null}
            className={`bg-gradient-to-r from-red-50 to-orange-50 border-2 border-red-200 rounded-lg p-4 shadow-sm hover:shadow-md transition-all ${userPermissions.can_view_diagnostics ? 'cursor-pointer hover:border-red-300' : 'opacity-75'} relative`}
          >
            {/* Netix Logo Badge */}
            <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
              <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-red-100 rounded-full p-3">
                  <Activity className="h-6 w-6 text-red-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    Network Diagnostics
                    {!userPermissions.can_view_diagnostics && <Shield className="h-4 w-4 text-gray-400" />}
                  </h3>
                  <p className="text-sm text-gray-600">Auto-detect issues, alerts & auto-remediation</p>
                </div>
              </div>
              {userPermissions.can_view_diagnostics ? (
                <Button
                  size="sm"
                  className="bg-red-500 text-white hover:bg-red-600"
                >
                  View Diagnostics →
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('Network Diagnostics', 'can_view_diagnostics');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              )}
            </div>
          </div>

          {/* Network Performance Map Card - Show with request access if no permission */}
          <div 
            onClick={userPermissions.can_view_performance_map ? () => navigate('/monitoring-dashboard/performance-map') : null}
            className={`bg-gradient-to-r from-cyan-50 to-blue-50 border-2 border-cyan-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all ${userPermissions.can_view_performance_map ? 'cursor-pointer hover:border-cyan-400' : 'opacity-75'} relative`}
          >
            {/* Netix Logo Badge */}
            <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
              <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-cyan-100 rounded-full p-3">
                  <MapPin className="h-6 w-6 text-cyan-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    Performance Map
                    {!userPermissions.can_view_performance_map && <Shield className="h-4 w-4 text-gray-400" />}
                  </h3>
                  <p className="text-sm text-gray-600">Real-time network performance visualization</p>
                </div>
              </div>
              {userPermissions.can_view_performance_map ? (
                <Button
                  size="sm"
                  className="bg-cyan-500 text-white hover:bg-cyan-600"
                >
                  View Map →
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('Performance Map', 'can_view_performance_map');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              )}
            </div>
          </div>

          {/* Bandwidth Management Card - Show with request access if no permission */}
          <div 
            onClick={userPermissions.can_manage_users ? () => navigate('/monitoring-dashboard/bandwidth') : null}
            className={`bg-gradient-to-r from-purple-50 to-pink-50 border-2 border-purple-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all ${userPermissions.can_manage_users ? 'cursor-pointer hover:border-purple-400' : 'opacity-75'} relative`}
          >
            {/* Netix Logo Badge */}
            <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
              <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-purple-100 rounded-full p-3">
                  <Activity className="h-6 w-6 text-purple-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    Bandwidth Management
                    {!userPermissions.can_manage_users && <Shield className="h-4 w-4 text-gray-400" />}
                  </h3>
                  <p className="text-sm text-gray-600">FUP monitoring, throttling & usage analytics</p>
                </div>
              </div>
              {userPermissions.can_manage_users ? (
                <Button
                  size="sm"
                  className="bg-purple-500 text-white hover:bg-purple-600"
                >
                  Manage →
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('Bandwidth Management', 'can_manage_bandwidth');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              )}
            </div>
          </div>

          {/* Predictive Analytics Card - Admin Only */}
          {userPermissions.can_manage_users && (
            <div 
              onClick={() => navigate('/monitoring-dashboard/predictive-analytics')}
              className="bg-gradient-to-r from-purple-100 via-pink-100 to-purple-100 border-2 border-purple-400 rounded-lg p-4 shadow-md hover:shadow-lg transition-all cursor-pointer hover:border-purple-500 relative animate-pulse-slow"
            >
              {/* Netix Logo Badge */}
              <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
                <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
              </div>
              <div className="absolute top-2 left-2">
                <span className="bg-gradient-to-r from-purple-600 to-pink-600 text-white text-xs font-bold px-2 py-1 rounded-full">
                  🤖 AI-POWERED
                </span>
              </div>
              <div className="flex items-center justify-between mt-6">
                <div className="flex items-center gap-3">
                  <div className="bg-gradient-to-br from-purple-500 to-pink-500 rounded-full p-3">
                    <Brain className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold bg-gradient-to-r from-purple-700 to-pink-700 bg-clip-text text-transparent">
                      Predictive Network Analytics
                    </h3>
                    <p className="text-sm text-gray-700 font-semibold">AI predictions for connectivity & congestion</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  className="bg-gradient-to-r from-purple-600 to-pink-600 text-white hover:from-purple-700 hover:to-pink-700"
                >
                  View Analytics →
                </Button>
              </div>
            </div>
          )}

          {/* Notification Center Card - Show with request access if no permission */}
          <div 
            onClick={userPermissions.can_manage_users ? () => navigate('/monitoring-dashboard/notifications') : null}
            className={`bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all ${userPermissions.can_manage_users ? 'cursor-pointer hover:border-green-400' : 'opacity-75'} relative`}
          >
            {/* Netix Logo Badge */}
            <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
              <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-green-100 rounded-full p-3">
                  <Bell className="h-6 w-6 text-green-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    Notification Center
                    {!userPermissions.can_manage_users && <Shield className="h-4 w-4 text-gray-400" />}
                  </h3>
                  <p className="text-sm text-gray-600">SMS, Email, WhatsApp & bulk messaging</p>
                </div>
              </div>
              {userPermissions.can_manage_users ? (
                <Button
                  size="sm"
                  className="bg-green-500 text-white hover:bg-green-600"
                >
                  Open →
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('Notification Center', 'can_manage_notifications');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              )}
            </div>
          </div>

          {/* Visual Analytics Dashboard Card - Show with request access if no permission */}
          <div 
            onClick={userPermissions.can_manage_users ? () => navigate('/monitoring-dashboard/visual-analytics') : null}
            className={`bg-gradient-to-r from-orange-50 to-yellow-50 border-2 border-orange-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all ${userPermissions.can_manage_users ? 'cursor-pointer hover:border-orange-400' : 'opacity-75'} relative`}
          >
            {/* Netix Logo Badge */}
            <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
              <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-orange-100 rounded-full p-3">
                  <Activity className="h-6 w-6 text-orange-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    Visual Analytics Dashboard
                    {!userPermissions.can_manage_users && <Shield className="h-4 w-4 text-gray-400" />}
                  </h3>
                  <p className="text-sm text-gray-600">Bandwidth, customer growth & network health</p>
                </div>
              </div>
              {userPermissions.can_manage_users ? (
                <Button
                  size="sm"
                  className="bg-orange-500 text-white hover:bg-orange-600"
                >
                  View Dashboard →
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('Visual Analytics Dashboard', 'can_view_analytics');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              )}
            </div>
          </div>

          {/* Email Communication Center Card - Show with request access if no permission */}
          <div 
            onClick={userPermissions.can_manage_users ? () => navigate('/monitoring-dashboard/email-center') : null}
            className={`bg-gradient-to-r from-red-50 to-pink-50 border-2 border-red-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all ${userPermissions.can_manage_users ? 'cursor-pointer hover:border-red-400' : 'opacity-75'} relative`}
          >
            {/* Netix Logo Badge */}
            <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
              <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="bg-red-100 rounded-full p-3">
                  <Mail className="h-6 w-6 text-red-600" />
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                    Email Communication Center
                    {!userPermissions.can_manage_users && <Shield className="h-4 w-4 text-gray-400" />}
                  </h3>
                  <p className="text-sm text-gray-600">Send updates, usage reports & notifications</p>
                </div>
              </div>
              {userPermissions.can_manage_users ? (
                <Button
                  size="sm"
                  className="bg-red-500 text-white hover:bg-red-600"
                >
                  Open →
                </Button>
              ) : (
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('Email Communication Center', 'can_send_emails');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              )}
            </div>
          </div>

          {/* WhatsApp Dashboard Card - Admin always has access, sub-users need permission */}
          {(userPermissions.can_manage_users || userPermissions.can_access_whatsapp) && (
            <div 
              onClick={() => navigate('/monitoring-dashboard/whatsapp')}
              className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer hover:border-green-400 relative"
            >
              {/* Netix Logo Badge */}
              <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
                <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-green-100 rounded-full p-3">
                    <Phone className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900">WhatsApp Dashboard</h3>
                    <p className="text-sm text-gray-600">Chat, send messages & manage conversations</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  className="bg-green-500 text-white hover:bg-green-600"
                >
                  Open Chat →
                </Button>
              </div>
            </div>
          )}

          {/* WhatsApp Dashboard Request Access Card - Only for sub-users without permission */}
          {!userPermissions.can_manage_users && !userPermissions.can_access_whatsapp && (
            <div 
              className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-lg p-4 shadow-sm opacity-75 relative"
            >
              {/* Netix Logo Badge */}
              <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
                <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
              </div>
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-green-100 rounded-full p-3">
                    <Phone className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                      WhatsApp Dashboard
                      <Shield className="h-4 w-4 text-gray-400" />
                    </h3>
                    <p className="text-sm text-gray-600">Chat, send messages & manage conversations</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRequestFeatureAccess('WhatsApp Dashboard', 'can_access_whatsapp');
                  }}
                  className="bg-blue-500 text-white hover:bg-blue-600"
                >
                  Request Access
                </Button>
              </div>
            </div>
          )}

          {/* Live Traffic Monitor Card - Admin Only (Moved inside Network Dashboard) */}
          {userPermissions.can_manage_users && (
            <div 
              onClick={() => navigate('/monitoring-dashboard/live-traffic')}
              className="relative bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-300 rounded-lg p-4 shadow-sm hover:shadow-md transition-all cursor-pointer hover:border-green-400 overflow-hidden group"
            >
              {/* Netix Logo Badge */}
              <div className="absolute top-2 right-2 bg-white rounded-md p-1 shadow-sm">
                <img src="/netix-logo-horizontal.png" alt="Netix" className="h-4 w-auto opacity-60" />
              </div>
              
              {/* Animated pulse effect */}
              <div className="absolute top-2 left-2">
                <div className="w-3 h-3 bg-green-500 rounded-full animate-ping" />
                <div className="absolute top-0 left-0 w-3 h-3 bg-green-500 rounded-full" />
              </div>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-green-100 rounded-full p-3 animate-pulse">
                    <Radio className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 flex items-center gap-2">
                      🔴 Live Traffic Monitor
                      <span className="text-xs bg-red-500 text-white px-2 py-1 rounded-full animate-pulse">
                        LIVE
                      </span>
                    </h3>
                    <p className="text-sm text-gray-600">Real-time traffic • Updates every 3 seconds</p>
                  </div>
                </div>
                <Button
                  size="sm"
                  className="bg-green-500 text-white hover:bg-green-600"
                >
                  View Live →
                </Button>
              </div>
            </div>
          )}
            </div>
          )}
        </div>

        {/* Search and Filter Bar */}
        <div className="flex gap-3 mb-4">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
            <Input
              placeholder="Search customers, office, city, IP..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="pl-10"
            />
          </div>
          <div className="flex gap-2">
            {['all', 'active', 'inactive', 'suspended'].map(status => (
              <Button
                key={status}
                size="sm"
                variant={statusFilter === status ? 'default' : 'outline'}
                onClick={() => setStatusFilter(status)}
                className="capitalize"
              >
                {status}
              </Button>
            ))}
          </div>
        </div>

        {/* Compact Eye-Catching Dynamic Stats Cards with Live Effects */}
        <div className="mb-3">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {/* Total Customers - Blue Gradient (Compact) */}
            <div className="relative group overflow-hidden rounded-lg shadow-xl hover:shadow-blue-500/50 transition-all duration-300 transform hover:scale-105">
              {/* Animated gradient background */}
              <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-blue-500 to-indigo-600 animate-gradient-xy bg-[length:200%_200%]"></div>
              
              {/* Floating particles */}
              <div className="absolute inset-0 opacity-30">
                <div className="absolute top-1 left-[20%] w-1.5 h-1.5 bg-white rounded-full animate-float"></div>
                <div className="absolute top-2 right-[30%] w-1 h-1 bg-blue-200 rounded-full animate-float" style={{ animationDelay: '0.5s' }}></div>
              </div>
              
              {/* Wave effect */}
              <div className="absolute inset-0 opacity-20">
                <div className="absolute inset-0 animate-wave bg-gradient-to-r from-transparent via-white to-transparent"></div>
              </div>
              
              <div className="relative z-10 p-3">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-1.5 mb-1">
                      <Activity className="h-3.5 w-3.5 text-white animate-pulse" />
                      <p className="text-xs font-bold text-white/90">Total</p>
                    </div>
                    <div className="flex items-baseline gap-1.5">
                      <p className="text-3xl font-black text-white drop-shadow-lg">{stats.total}</p>
                      <span className="text-xs text-white/80 font-semibold">accounts</span>
                    </div>
                  </div>
                  <div className="relative w-11 h-11 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                    <div className="absolute inset-0 bg-white/30 rounded-full animate-ping-slow"></div>
                    <Activity className="h-5 w-5 text-white" />
                  </div>
                </div>
              </div>
            </div>

            {/* Active Customers - Green Gradient (Compact) */}
            <div className="relative group overflow-hidden rounded-lg shadow-xl hover:shadow-green-500/50 transition-all duration-300 transform hover:scale-105">
              {/* Animated gradient background */}
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-400 via-green-500 to-teal-600 animate-gradient-xy bg-[length:200%_200%]"></div>
              
              {/* Floating particles */}
              <div className="absolute inset-0 opacity-30">
                <div className="absolute top-2 left-[15%] w-1.5 h-1.5 bg-white rounded-full animate-float-reverse"></div>
                <div className="absolute top-1 right-[25%] w-1 h-1 bg-emerald-200 rounded-full animate-float-reverse" style={{ animationDelay: '0.3s' }}></div>
              </div>
              
              {/* Radial glow */}
              <div className="absolute top-0 right-0 w-20 h-20 bg-emerald-300 rounded-full blur-2xl opacity-30 animate-pulse-slow"></div>
              
              <div className="relative z-10 p-3">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-1.5 mb-1">
                      <div className="w-2 h-2 bg-white rounded-full animate-ping"></div>
                      <p className="text-xs font-bold text-white/90">Active</p>
                    </div>
                    <div className="flex items-baseline gap-2">
                      <p className="text-3xl font-black text-white drop-shadow-lg">{stats.active}</p>
                      <div className="flex flex-col">
                        <span className="text-lg text-white font-black">
                          {stats.total > 0 ? Math.round((stats.active / stats.total) * 100) : 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="relative w-11 h-11 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                    <div className="absolute inset-0 bg-white/30 rounded-full animate-ping"></div>
                    <Wifi className="h-5 w-5 text-white animate-pulse" />
                  </div>
                </div>
                {/* Compact animated progress bar */}
                <div className="mt-2 h-1.5 bg-white/20 rounded-full overflow-hidden shadow-inner">
                  <div 
                    className="h-full bg-gradient-to-r from-white via-emerald-200 to-white animate-shimmer bg-[length:200%_100%] transition-all duration-1000"
                    style={{ width: `${stats.total > 0 ? (stats.active / stats.total) * 100 : 0}%` }}
                  ></div>
                </div>
              </div>
            </div>

            {/* Inactive Customers - Red/Orange Gradient (Compact) */}
            <div className="relative group overflow-hidden rounded-lg shadow-xl hover:shadow-red-500/50 transition-all duration-300 transform hover:scale-105">
              {/* Animated gradient background */}
              <div className="absolute inset-0 bg-gradient-to-br from-orange-400 via-red-500 to-pink-600 animate-gradient-xy bg-[length:200%_200%]"></div>
              
              {/* Floating particles */}
              <div className="absolute inset-0 opacity-30">
                <div className="absolute top-1 left-[30%] w-1.5 h-1.5 bg-white rounded-full animate-float"></div>
                <div className="absolute top-2 right-[20%] w-1 h-1 bg-orange-200 rounded-full animate-float" style={{ animationDelay: '0.4s' }}></div>
              </div>
              
              {/* Radial glow */}
              <div className="absolute bottom-0 left-0 w-20 h-20 bg-red-300 rounded-full blur-2xl opacity-30 animate-pulse-slow" style={{ animationDelay: '0.5s' }}></div>
              
              <div className="relative z-10 p-3">
                <div className="flex items-center justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-1.5 mb-1">
                      <div className="w-2 h-2 bg-white rounded-full animate-pulse"></div>
                      <p className="text-xs font-bold text-white/90">Inactive</p>
                    </div>
                    <div className="flex items-baseline gap-2">
                      <p className="text-3xl font-black text-white drop-shadow-lg">{stats.inactive}</p>
                      <div className="flex flex-col">
                        <span className="text-lg text-white font-black">
                          {stats.total > 0 ? Math.round((stats.inactive / stats.total) * 100) : 0}%
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="relative w-11 h-11 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
                    <div className="absolute inset-0 bg-white/30 rounded-full animate-ping-slow"></div>
                    <WifiOff className="h-5 w-5 text-white" />
                  </div>
                </div>
                {/* Compact animated progress bar */}
                <div className="mt-2 h-1.5 bg-white/20 rounded-full overflow-hidden shadow-inner">
                  <div 
                    className="h-full bg-gradient-to-r from-white via-red-200 to-white animate-shimmer bg-[length:200%_100%] transition-all duration-1000"
                    style={{ width: `${stats.total > 0 ? (stats.inactive / stats.total) * 100 : 0}%` }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Live Customer Cards with MRTG Graphs - Collapsible */}
        <div className="mb-6">
          <button
            onClick={() => setShowLiveStatus(!showLiveStatus)}
            className="w-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 text-white rounded-lg p-4 hover:from-blue-600 hover:via-purple-600 hover:to-pink-600 transition-all shadow-md hover:shadow-lg"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="relative">
                  <Activity className="h-6 w-6" />
                  <div className="absolute -top-1 -right-1 w-2 h-2 bg-green-400 rounded-full animate-ping" />
                </div>
                <div className="text-left">
                  <h2 className="text-xl font-bold">Live Customer Status</h2>
                  <p className="text-sm text-white/80">Real-time monitoring • {stats.active} Active • {stats.inactive} Inactive</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-3 py-1">
                  <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                  <span className="text-sm font-medium">Live</span>
                </div>
                {showLiveStatus ? (
                  <ChevronUp className="h-6 w-6" />
                ) : (
                  <ChevronDown className="h-6 w-6" />
                )}
              </div>
            </div>
          </button>
          
          {showLiveStatus && (
            <div className="mt-4 animate-fadeIn">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {filteredCustomers.map((customer) => {
              const isExpanded = expandedCards.has(customer.id);
              const rechargeStatus = getRechargeStatus(customer);
              
              // Determine card color based on status and inactivity reason
              const getCardColors = () => {
                // Broadband / Enterprise Broadband: recharge-based color coding
                if (rechargeStatus) {
                  if (rechargeStatus.daysLeft > 5) {
                    return {
                      border: 'border-green-400',
                      bg: 'bg-gradient-to-br from-green-50 via-emerald-50 to-white',
                      glow: 'shadow-green-100',
                      accent: 'from-green-400 via-emerald-500 to-teal-400',
                      dot: 'bg-green-500',
                      badge: 'bg-green-500 text-white',
                      statusBg: 'bg-gradient-to-r from-green-100 to-emerald-100 border-green-200',
                      statusText: 'text-green-700',
                      headerBg: 'bg-gradient-to-r from-green-500 to-emerald-500'
                    };
                  } else if (rechargeStatus.daysLeft > 3) {
                    return {
                      border: 'border-yellow-400',
                      bg: 'bg-gradient-to-br from-yellow-50 via-amber-50 to-white',
                      glow: 'shadow-yellow-100',
                      accent: 'from-yellow-400 via-amber-400 to-yellow-500',
                      dot: 'bg-yellow-500',
                      badge: 'bg-yellow-500 text-white',
                      statusBg: 'bg-gradient-to-r from-yellow-100 to-amber-100 border-yellow-200',
                      statusText: 'text-yellow-700',
                      headerBg: 'bg-gradient-to-r from-yellow-500 to-amber-500'
                    };
                  } else {
                    return {
                      border: 'border-red-400',
                      bg: 'bg-gradient-to-br from-red-50 via-rose-50 to-white',
                      glow: 'shadow-red-100',
                      accent: 'from-red-400 via-rose-500 to-pink-400',
                      dot: 'bg-red-500',
                      badge: 'bg-red-500 text-white',
                      statusBg: 'bg-gradient-to-r from-red-100 to-rose-100 border-red-200',
                      statusText: 'text-red-700',
                      headerBg: 'bg-gradient-to-r from-red-500 to-rose-500'
                    };
                  }
                }
                if (customer.status === 'active') {
                  return {
                    border: 'border-green-400',
                    bg: 'bg-gradient-to-br from-green-50 via-emerald-50 to-white',
                    glow: 'shadow-green-100',
                    accent: 'from-green-400 via-emerald-500 to-teal-400',
                    dot: 'bg-green-500',
                    badge: 'bg-green-500 text-white',
                    statusBg: 'bg-gradient-to-r from-green-100 to-emerald-100 border-green-200',
                    statusText: 'text-green-700',
                    headerBg: 'bg-gradient-to-r from-green-500 to-emerald-500'
                  };
                } else if (customer.status === 'suspended') {
                  return {
                    border: 'border-amber-400',
                    bg: 'bg-gradient-to-br from-amber-50 via-yellow-50 to-white',
                    glow: 'shadow-amber-100',
                    accent: 'from-amber-400 via-yellow-500 to-orange-400',
                    dot: 'bg-amber-500',
                    badge: 'bg-amber-500 text-white',
                    statusBg: 'bg-gradient-to-r from-amber-100 to-yellow-100 border-amber-200',
                    statusText: 'text-amber-700',
                    headerBg: 'bg-gradient-to-r from-amber-500 to-yellow-500'
                  };
                } else {
                  const reason = customer.inactivity_reason || 'Local Power Issue';
                  if (reason === 'Payment Issue') {
                    return {
                      border: 'border-yellow-400',
                      bg: 'bg-gradient-to-br from-yellow-50 via-amber-50 to-white',
                      glow: 'shadow-yellow-100',
                      accent: 'from-yellow-400 via-amber-400 to-yellow-500',
                      dot: 'bg-yellow-500',
                      badge: 'bg-yellow-500 text-white',
                      statusBg: 'bg-gradient-to-r from-yellow-100 to-amber-100 border-yellow-200',
                      statusText: 'text-yellow-700',
                      headerBg: 'bg-gradient-to-r from-yellow-500 to-amber-500'
                    };
                  } else if (reason === 'Under Maintenance') {
                    return {
                      border: 'border-pink-400',
                      bg: 'bg-gradient-to-br from-pink-50 via-rose-50 to-white',
                      glow: 'shadow-pink-100',
                      accent: 'from-pink-400 via-rose-400 to-fuchsia-400',
                      dot: 'bg-pink-500',
                      badge: 'bg-pink-500 text-white',
                      statusBg: 'bg-gradient-to-r from-pink-100 to-rose-100 border-pink-200',
                      statusText: 'text-pink-700',
                      headerBg: 'bg-gradient-to-r from-pink-500 to-rose-500'
                    };
                  } else if (reason === 'Link Down') {
                    return {
                      border: 'border-orange-400',
                      bg: 'bg-gradient-to-br from-orange-50 via-amber-50 to-white',
                      glow: 'shadow-orange-100',
                      accent: 'from-orange-400 via-red-400 to-orange-500',
                      dot: 'bg-orange-500',
                      badge: 'bg-orange-500 text-white',
                      statusBg: 'bg-gradient-to-r from-orange-100 to-red-100 border-orange-200',
                      statusText: 'text-orange-700',
                      headerBg: 'bg-gradient-to-r from-orange-500 to-red-500'
                    };
                  } else {
                    return {
                      border: 'border-red-400',
                      bg: 'bg-gradient-to-br from-red-50 via-rose-50 to-white',
                      glow: 'shadow-red-100',
                      accent: 'from-red-400 via-rose-500 to-pink-400',
                      dot: 'bg-red-500',
                      badge: 'bg-red-500 text-white',
                      statusBg: 'bg-gradient-to-r from-red-100 to-rose-100 border-red-200',
                      statusText: 'text-red-700',
                      headerBg: 'bg-gradient-to-r from-red-500 to-rose-500'
                    };
                  }
                }
              };
              
              const colors = getCardColors();
              
              return (
                <Card 
                  key={customer.id} 
                  data-customer-id={customer.id}
                  data-testid={`customer-card-${customer.id}`}
                  className={`relative overflow-hidden transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl border-2 ${colors.border} bg-white shadow-lg ${colors.glow} rounded-xl`}
                >
                  {/* Colored Header Bar with Status - Compact */}
                  <div className={`${colors.headerBg} px-3 py-2 flex items-center justify-between`}>
                    <div className="flex items-center gap-1.5">
                      {/* Live Indicator */}
                      <div className="relative">
                        <div className={`w-2.5 h-2.5 ${colors.dot} rounded-full ${customer.status === 'active' ? 'animate-pulse' : ''}`}></div>
                        {customer.status === 'active' && (
                          <div className="absolute inset-0 w-2.5 h-2.5 bg-white rounded-full animate-ping opacity-50"></div>
                        )}
                      </div>
                      <span className="text-white font-bold text-xs uppercase tracking-wide">
                        {rechargeStatus ? (rechargeStatus.daysLeft >= 0 ? 'active' : 'inactive') : customer.status}
                      </span>
                    </div>
                    {/* Duration Badge */}
                    {rechargeStatus ? (
                      <span 
                        className={`text-[10px] font-bold px-1.5 py-0.5 rounded-full ${rechargeStatus.headerBadge}`}
                        data-testid={`due-date-badge-${customer.id}`}
                        title={`Recharged: ${customer.last_recharge_date} · Due: ${rechargeStatus.dueDate}`}
                      >
                        Active: {rechargeStatus.activeDays}d / {rechargeStatus.totalDays}d
                      </span>
                    ) : customer.status === 'active' && customer.active_since ? (
                      <span 
                        className="bg-white/20 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full backdrop-blur-sm cursor-help"
                        title={formatFullTimestamp(customer.active_since)}
                      >
                        {formatActiveSince(customer.active_since)}
                      </span>
                    ) : customer.status === 'inactive' && customer.inactive_since ? (
                      <span 
                        className="bg-white/20 text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full backdrop-blur-sm cursor-help"
                        title={formatFullTimestamp(customer.inactive_since)}
                      >
                        {formatActiveSince(customer.inactive_since)}
                      </span>
                    ) : null}
                  </div>
                  
                  <CardContent className="p-3">
                    {/* Office Name - Compact */}
                    <h3 className="font-bold text-sm text-gray-800 leading-tight mb-2 line-clamp-2">
                      {customer.office_name}
                    </h3>
                    
                    {/* Info Grid - Compact stacked layout */}
                    <div className="space-y-1.5 mb-2">
                      {/* IP Address */}
                      <div className="bg-blue-50 rounded-lg px-2.5 py-1.5 flex items-center gap-2">
                        <div className="w-6 h-6 bg-blue-500 rounded-full flex items-center justify-center shrink-0">
                          <Globe className="h-3 w-3 text-white" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="text-[9px] text-blue-600 font-bold uppercase tracking-wide">IP Address</div>
                          <div className="text-xs font-mono text-gray-800 font-bold">{customer.static_ip}</div>
                        </div>
                      </div>
                      
                      {/* Circuit ID */}
                      <div className="bg-purple-50 rounded-lg px-2.5 py-1.5 flex items-center gap-2">
                        <div className="w-6 h-6 bg-purple-500 rounded-full flex items-center justify-center shrink-0">
                          <Zap className="h-3 w-3 text-white" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="text-[9px] text-purple-600 font-bold uppercase tracking-wide">Circuit ID</div>
                          <div className="text-xs font-mono text-gray-800 font-bold">{customer.circuit_id || 'N/A'}</div>
                        </div>
                      </div>
                      
                      {/* Broadband / Recharge Details - minimized by default */}
                      {(customer.broadband_account_number || customer.plan_speed || customer.last_recharge_date) && (
                        <div className="bg-cyan-50 rounded-lg px-2.5 py-1.5" data-testid={`broadband-info-${customer.id}`}>
                          <div className="flex items-center justify-between gap-1">
                            <div className="text-[9px] text-cyan-700 font-bold uppercase tracking-wide">Broadband / Recharge</div>
                            <div className="flex items-center gap-1">
                              {rechargeStatus && (
                                <span className={`inline-flex items-center gap-1 text-[9px] font-bold px-1.5 py-0.5 rounded-full border ${rechargeStatus.cls}`} data-testid={`recharge-status-${customer.id}`}>
                                  <span className={`w-1.5 h-1.5 rounded-full ${rechargeStatus.dot}`}></span>
                                  {rechargeStatus.label}
                                </span>
                              )}
                              <button
                                onClick={() => {
                                  setExpandedRecharge(prev => {
                                    const next = new Set(prev);
                                    if (next.has(customer.id)) next.delete(customer.id); else next.add(customer.id);
                                    return next;
                                  });
                                }}
                                className="text-cyan-700 hover:text-cyan-900 p-0.5 rounded hover:bg-cyan-100 transition-colors"
                                data-testid={`broadband-toggle-${customer.id}`}
                                title={expandedRecharge.has(customer.id) ? 'Minimize details' : 'Show details'}
                              >
                                {expandedRecharge.has(customer.id) ? <ChevronUp className="h-3.5 w-3.5" /> : <ChevronDown className="h-3.5 w-3.5" />}
                              </button>
                            </div>
                          </div>
                          {expandedRecharge.has(customer.id) && (
                          <div className="grid grid-cols-2 gap-x-2 gap-y-0.5 text-[10px] text-gray-700 mt-1" data-testid={`broadband-details-${customer.id}`}>
                            {customer.broadband_account_number && (
                              <div className="col-span-2"><span className="text-gray-400 font-semibold">A/C No:</span> <span className="font-mono font-bold">{customer.broadband_account_number}</span></div>
                            )}
                            {customer.plan_speed && (
                              <div><span className="text-gray-400 font-semibold">Plan:</span> <span className="font-bold">{customer.plan_speed}</span></div>
                            )}
                            {customer.plan_duration_months ? (
                              <div><span className="text-gray-400 font-semibold">Duration:</span> <span className="font-bold">{customer.plan_duration_months} {parseInt(customer.plan_duration_months) === 1 ? 'Month' : 'Months'}</span></div>
                            ) : null}
                            {customer.last_recharge_date && (
                              <div><span className="text-gray-400 font-semibold">Recharged:</span> <span className="font-bold">{new Date(customer.last_recharge_date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span></div>
                            )}
                            {customer.last_recharge_amount ? (
                              <div><span className="text-gray-400 font-semibold">Amount:</span> <span className="font-bold">₹{customer.last_recharge_amount}</span></div>
                            ) : null}
                            {rechargeStatus && (
                              <div className="col-span-2"><span className="text-gray-400 font-semibold">Due Date:</span> <span className={`font-bold ${rechargeStatus.daysLeft <= 3 ? 'text-red-600' : rechargeStatus.daysLeft <= 5 ? 'text-yellow-600' : 'text-green-700'}`} data-testid={`due-date-${customer.id}`}>{rechargeStatus.dueDate}</span></div>
                            )}
                          </div>
                          )}
                        </div>
                      )}
                    </div>
                    
                    {/* Status Timeline Box - Compact */}
                    <div className={`rounded-lg px-2.5 py-1.5 border ${colors.statusBg} mb-2`}>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-1.5">
                          <div className={`w-2 h-2 rounded-full ${colors.dot} ${customer.status === 'active' ? 'animate-pulse' : ''}`}></div>
                          <span className={`text-xs font-bold ${colors.statusText} uppercase`}>
                            {rechargeStatus
                              ? (rechargeStatus.daysLeft >= 0 ? 'Recharge Active' : 'Recharge Expired')
                              : (customer.status === 'active' ? 'Online' : customer.status === 'suspended' ? 'Suspended' : 'Offline')}
                          </span>
                        </div>
                        <div className="text-right">
                          {rechargeStatus ? (
                            <div>
                              <div className="text-[9px] text-gray-500 uppercase font-semibold">Due Date</div>
                              <div className={`text-xs font-bold ${colors.statusText}`}>{rechargeStatus.dueDate}</div>
                            </div>
                          ) : customer.status === 'active' && customer.active_since ? (
                            <div 
                              className="cursor-help group relative"
                              title={formatFullTimestamp(customer.active_since)}
                            >
                              <div className="text-[9px] text-gray-500 uppercase font-semibold">Since</div>
                              <div className={`text-xs font-bold ${colors.statusText} underline decoration-dotted decoration-gray-400`}>{formatSinceWhen(customer.active_since)}</div>
                            </div>
                          ) : customer.status === 'inactive' && customer.inactive_since ? (
                            <div 
                              className="cursor-help group relative"
                              title={formatFullTimestamp(customer.inactive_since)}
                            >
                              <div className="text-[9px] text-gray-500 uppercase font-semibold">Down Since</div>
                              <div className={`text-xs font-bold ${colors.statusText} underline decoration-dotted decoration-gray-400`}>{formatSinceWhen(customer.inactive_since)}</div>
                            </div>
                          ) : (
                            <div className="text-xs text-gray-400">--</div>
                          )}
                        </div>
                      </div>
                    </div>
                    
                    {/* Inactivity Reason - Compact (hidden for Broadband/Enterprise Broadband) */}
                    {customer.status === 'inactive' && !['Broadband', 'Enterprise Broadband'].includes(customer.service) && (
                      <div className={`rounded-lg px-2.5 py-1.5 border ${colors.statusBg} mb-2`}>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-1.5">
                            <AlertCircle className={`h-3.5 w-3.5 ${colors.statusText}`} />
                            <span className="text-[9px] font-bold text-gray-600 uppercase">Issue</span>
                          </div>
                          {userPermissions.can_manage_users ? (
                            <select
                              value={customer.inactivity_reason || 'Local Power Issue'}
                              onChange={async (e) => {
                                const newReason = e.target.value;
                                try {
                                  const token = localStorage.getItem('monitoringAdminToken');
                                  if (!token) {
                                    toast.error('Please login again');
                                    return;
                                  }
                                  const response = await fetch(`${API_URL}/api/customer-monitoring/customers/${customer.id}/inactivity-reason`, {
                                    method: 'PUT',
                                    headers: {
                                      'Content-Type': 'application/json',
                                      'Authorization': `Bearer ${token}`
                                    },
                                    body: JSON.stringify({ inactivity_reason: newReason })
                                  });
                                  if (response.ok) {
                                    toast.success('Reason updated');
                                    setCustomers(prev => prev.map(c => 
                                      c.id === customer.id ? { ...c, inactivity_reason: newReason } : c
                                    ));
                                  } else {
                                    const errorData = await response.json().catch(() => ({}));
                                    console.error('Update failed:', response.status, errorData);
                                    toast.error(errorData.detail || `Update failed (${response.status})`);
                                  }
                                } catch (error) {
                                  console.error('Error updating reason:', error);
                                  toast.error('Network error');
                                }
                              }}
                              className={`text-[10px] font-bold px-1.5 py-0.5 rounded border ${colors.border} bg-white cursor-pointer ${colors.statusText}`}
                              data-testid={`inactivity-reason-${customer.id}`}
                            >
                              <option value="Local Power Issue">⚡ Power Issue</option>
                              <option value="Link Down">🔗 Link Down</option>
                              <option value="Under Maintenance">🔧 Maintenance</option>
                              <option value="Payment Issue">💳 Payment Issue</option>
                            </select>
                          ) : (
                            <span className={`text-[10px] font-bold px-2 py-0.5 rounded ${colors.badge}`}>
                              {customer.inactivity_reason === 'Local Power Issue' ? '⚡ Power Issue' : 
                               customer.inactivity_reason === 'Link Down' ? '🔗 Link Down' :
                               customer.inactivity_reason === 'Under Maintenance' ? '🔧 Maintenance' : 
                               customer.inactivity_reason === 'Payment Issue' ? '💳 Payment' : 
                               '⚡ Power Issue'}
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    
                    {/* Location Info - Compact */}
                    <div className="flex items-center gap-1.5 text-[10px] text-gray-500 mb-2">
                      <MapPin className="h-3 w-3 text-gray-400" />
                      <span className="font-medium">{customer.city}, {customer.state}</span>
                    </div>
                    
                    {/* Action Button - Compact */}
                    <button
                      onClick={() => toggleCardExpanded(customer.id)}
                      className={`w-full flex items-center justify-center gap-1 py-1.5 text-[10px] font-bold rounded-lg transition-all ${
                        isExpanded 
                          ? 'bg-gray-100 text-gray-700' 
                          : `${colors.statusBg} ${colors.statusText} hover:opacity-80`
                      }`}
                    >
                      {isExpanded ? (
                        <>
                          <ChevronUp className="h-3 w-3" />
                          <span>Less Details</span>
                        </>
                      ) : (
                        <>
                          <ChevronDown className="h-3 w-3" />
                          <span>More Details</span>
                        </>
                      )}
                    </button>
                    
                    {/* Expanded Details - Compact */}
                    {isExpanded && (
                      <div className="mt-2 pt-2 border-t border-gray-100 space-y-2 animate-in fade-in duration-200">
                        {/* Customer Name */}
                        <div className="bg-gray-50 rounded-lg px-2 py-1.5">
                          <div className="flex items-center gap-2">
                            <Building2 className="h-3.5 w-3.5 text-gray-500" />
                            <div>
                              <div className="text-[9px] text-gray-400 uppercase font-semibold">Customer Name</div>
                              <div className="text-xs font-bold text-gray-700">{customer.customer_name}</div>
                            </div>
                          </div>
                        </div>
                        
                        {/* Uptime Graph */}
                        <div className="bg-gray-50 rounded-lg px-2 py-1.5">
                          <div className="flex items-center justify-between mb-1">
                            <span className="text-[9px] text-gray-500 uppercase font-bold">24 Hour Uptime</span>
                            <span className={`text-[10px] font-bold ${customer.status === 'active' ? 'text-green-600' : 'text-red-600'}`}>
                              {customer.status === 'active' ? '98%' : '42%'}
                            </span>
                          </div>
                          <div className="flex items-end h-8 gap-[2px] bg-white rounded p-1">
                            {Array.from({ length: 24 }, (_, i) => {
                              const uptime = customer.status === 'active' ? 
                                Math.random() * 0.3 + 0.7 : Math.random() * 0.5;
                              return (
                                <div
                                  key={i}
                                  className={`flex-1 rounded-t transition-all ${
                                    uptime > 0.8 ? 'bg-green-400' :
                                    uptime > 0.5 ? 'bg-yellow-400' : 'bg-red-400'
                                  }`}
                                  style={{ height: `${Math.max(uptime * 100, 10)}%` }}
                                />
                              );
                            })}
                          </div>
                        </div>
                        
                        {/* Last Ping Status */}
                        {customer.last_ping_status && (
                          <div className="flex items-center justify-between bg-gray-50 rounded-lg px-2 py-1.5">
                            <span className="text-[10px] text-gray-500 font-semibold">Last Ping</span>
                            <span className={`text-[10px] font-bold px-1.5 py-0.5 rounded ${
                              customer.last_ping_status === 'success' 
                                ? 'bg-green-100 text-green-700' 
                                : 'bg-red-100 text-red-700'
                            }`}>
                              {customer.last_ping_status === 'success' ? '✓ Success' : '✗ Failed'}
                            </span>
                          </div>
                        )}
                      </div>
                    )}
                  </CardContent>
                </Card>
              );
            })}
              </div>
            </div>
          )}
        </div>

        {/* Compact Table - Collapsible & Scrollable */}
        <div className="mb-6">
          <button
            onClick={() => setShowCustomerTable(!showCustomerTable)}
            className="w-full bg-gradient-to-r from-slate-600 via-slate-700 to-slate-800 text-white rounded-lg p-4 hover:from-slate-700 hover:via-slate-800 hover:to-slate-900 transition-all shadow-md hover:shadow-lg"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Users className="h-5 w-5" />
                <div className="text-left">
                  <h2 className="text-lg font-bold">Customers ({filteredCustomers.length})</h2>
                  <p className="text-sm text-white/70">{stats.active} Active • {stats.inactive} Inactive</p>
                </div>
              </div>
              {showCustomerTable ? <ChevronUp className="h-5 w-5" /> : <ChevronDown className="h-5 w-5" />}
            </div>
          </button>
          
          {showCustomerTable && userPermissions.can_manage_users && (
            <div className="mt-2 flex justify-end">
              <Button
                onClick={handleDownloadCustomerData}
                className="bg-emerald-600 hover:bg-emerald-700 text-white"
                size="sm"
                data-testid="download-customer-data-btn"
              >
                <Download className="h-4 w-4 mr-2" />
                Download Customer Data
              </Button>
            </div>
          )}
          
          {showCustomerTable && (
            <Card className="mt-2">
              <CardContent className="p-0">
                {loading ? (
                  <div className="text-center py-8">Loading...</div>
                ) : filteredCustomers.length === 0 ? (
                  <div className="text-center py-8 text-gray-500">No customers found</div>
                ) : (
                  <div className="overflow-x-auto max-h-[350px] overflow-y-auto">
                    <table className="w-full text-xs">
                      <thead className="bg-gray-50 border-b sticky top-0 z-10">
                        <tr>
                          <th className="px-3 py-2 text-left text-xs font-semibold">Customer</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold">Location</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold">IP</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold">Plan / Recharge</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold">Status</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold">Active/Inactive Since</th>
                          <th className="px-3 py-2 text-left text-xs font-semibold">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y">
                        {filteredCustomers.map((customer) => (
                          <tr key={customer.id} className="hover:bg-gray-50">
                            <td className="px-3 py-2">
                              <div className="font-medium text-xs">{customer.customer_name}</div>
                              <div className="text-[10px] text-gray-500">{customer.office_name}</div>
                            </td>
                            <td className="px-3 py-2 text-[11px]">{customer.city}, {customer.state}</td>
                            <td className="px-3 py-2 font-mono text-[11px]">{customer.static_ip}</td>
                            <td className="px-3 py-2 text-[11px]">
                              {(customer.plan_speed || customer.last_recharge_date || customer.broadband_account_number) ? (
                                <div>
                                  <div className="font-medium">
                                    {customer.plan_speed || '--'}{customer.plan_duration_months ? ` · ${customer.plan_duration_months}mo` : ''}
                                  </div>
                                  {customer.broadband_account_number && (
                                    <div className="text-[10px] text-gray-500 font-mono">{customer.broadband_account_number}</div>
                                  )}
                                  {(() => {
                                    const rs = getRechargeStatus(customer);
                                    return rs ? (
                                      <div>
                                        <div className="text-[10px] text-gray-600">Due: <span className="font-semibold">{rs.dueDate}</span></div>
                                        <span className={`inline-block mt-0.5 px-1.5 py-0.5 rounded-full text-[9px] font-bold border ${rs.cls}`}>{rs.label}</span>
                                      </div>
                                    ) : null;
                                  })()}
                                </div>
                              ) : <span className="text-gray-400">--</span>}
                            </td>
                            <td className="px-3 py-2">
                              {(() => {
                                const rs = getRechargeStatus(customer);
                                if (rs) {
                                  return (
                                    <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                                      rs.daysLeft > 5 ? 'bg-green-100 text-green-800' :
                                      rs.daysLeft > 3 ? 'bg-yellow-100 text-yellow-800' :
                                      'bg-red-100 text-red-800'
                                    }`}>
                                      {rs.daysLeft >= 0 ? 'ACTIVE' : 'INACTIVE'}
                                    </span>
                                  );
                                }
                                return (
                                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                                    customer.status === 'active' ? 'bg-green-100 text-green-800' :
                                    customer.status === 'suspended' ? 'bg-orange-100 text-orange-800' :
                                    'bg-red-100 text-red-800'
                                  }`}>
                                    {customer.status.toUpperCase()}
                                  </span>
                                );
                              })()}
                            </td>
                            <td className="px-3 py-2 text-[11px]">
                              {customer.status === 'active' && customer.active_since ? (
                                <div 
                                  className="text-green-700 font-medium cursor-help"
                                  title={formatFullTimestamp(customer.active_since)}
                                >
                                  {formatActiveSince(customer.active_since)}
                                </div>
                              ) : customer.status === 'inactive' && customer.inactive_since ? (
                                <div 
                                  className="text-red-700 font-medium cursor-help"
                                  title={formatFullTimestamp(customer.inactive_since)}
                                >
                                  {formatActiveSince(customer.inactive_since)}
                                </div>
                              ) : 'N/A'}
                            </td>
                            <td className="px-3 py-2">
                              <div className="flex gap-1">
                                {userPermissions.can_edit_customer && (
                                  <Button size="sm" variant="outline" onClick={() => editCustomer(customer)} className="h-7 w-7 p-0" title="Edit Customer">
                                    <Edit className="h-3 w-3" />
                                  </Button>
                                )}
                                {userPermissions.can_manage_users && customer.router_ip && (
                                  <>
                                    <Button 
                                      size="sm" 
                                      variant="outline" 
                                      onClick={() => handleRouterLogin(customer)} 
                                      className="h-7 w-7 p-0 text-blue-600 hover:text-blue-800 hover:bg-blue-50"
                                      disabled={loadingRouter}
                                      title="Login to Router"
                                    >
                                      <LogIn className="h-3 w-3" />
                                    </Button>
                                    <Button 
                                      size="sm" 
                                      variant="outline" 
                                      onClick={() => openRouterControlPanel(customer)} 
                                      className="h-7 w-7 p-0 text-purple-600 hover:text-purple-800 hover:bg-purple-50"
                                      disabled={routerActionInProgress}
                                      title="Router Control"
                                    >
                                      <Settings className="h-3 w-3" />
                                    </Button>
                                  </>
                                )}
                                {userPermissions.can_delete_customer && (
                                  <Button size="sm" variant="outline" onClick={() => handleDelete(customer.id)} className="text-red-600 h-7 w-7 p-0" title="Delete Customer">
                                    <Trash2 className="h-3 w-3" />
                                  </Button>
                                )}
                                {!userPermissions.can_edit_customer && !userPermissions.can_delete_customer && (
                                  <span className="text-xs text-gray-400 px-2">View Only</span>
                                )}
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </CardContent>
            </Card>
          )}
        </div>
      </div>

      {/* Add/Edit Modal */}
      {showAddModal && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999] p-4">
          <div ref={modalRef} className="bg-white rounded-xl shadow-2xl p-6 max-w-lg w-full my-auto max-h-[85vh] overflow-y-auto relative z-[10000]">
            <h2 className="text-xl font-bold mb-4 pb-3 border-b">
              {editingCustomer ? 'Edit Customer' : 'Add Customer'}
            </h2>
            <div className="space-y-4 mb-4">
              {/* Basic Information */}
              <div className="space-y-3">
                <h3 className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                  <Activity className="h-4 w-4" />
                  Basic Information
                </h3>
                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Customer Name *</label>
                    <Input
                      value={formData.customer_name}
                      onChange={(e) => setFormData({ ...formData, customer_name: e.target.value })}
                      placeholder="Reliance Industries"
                      className="w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Office Name *</label>
                    <Input
                      value={formData.office_name}
                      onChange={(e) => setFormData({ ...formData, office_name: e.target.value })}
                      placeholder="Mumbai Office"
                      className="w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Static IP Address *</label>
                    <Input
                      value={formData.static_ip}
                      onChange={(e) => setFormData({ ...formData, static_ip: e.target.value })}
                      placeholder="103.21.124.15"
                      className="w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5 flex items-center gap-2">
                      <Zap className="h-4 w-4 text-purple-600" />
                      Circuit ID (Number Only)
                    </label>
                    <Input
                      type="number"
                      value={formData.circuit_id || ''}
                      onChange={(e) => setFormData({ ...formData, circuit_id: e.target.value })}
                      placeholder="1234567890"
                      className="w-full"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      🔗 Enter numeric circuit identifier only (e.g., 1234567890)
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5 flex items-center gap-2">
                      <Mail className="h-4 w-4 text-blue-600" />
                      Customer Email (For Communication)
                    </label>
                    <Input
                      type="email"
                      value={formData.email || ''}
                      onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                      placeholder="customer@example.com"
                      className="w-full"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      📧 This email will be used for sending updates & notifications
                    </p>
                  </div>
                </div>
              </div>

              {/* Location Information */}
              <div className="space-y-3 pt-3 border-t">
                <h3 className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                  <MapPin className="h-4 w-4" />
                  Location
                </h3>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">City *</label>
                    <Input
                      value={formData.city}
                      onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                      placeholder="Mumbai"
                      className="w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">State *</label>
                    <Input
                      value={formData.state}
                      onChange={(e) => setFormData({ ...formData, state: e.target.value })}
                      placeholder="Maharashtra"
                      className="w-full"
                    />
                  </div>
                </div>
              </div>

              {/* Service Details */}
              <div className="space-y-3 pt-3 border-t">
                <h3 className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                  <Wifi className="h-4 w-4" />
                  Service Details
                </h3>
                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">ISP (Internet Service Provider)</label>
                    <select
                      value={formData.isp}
                      onChange={(e) => setFormData({ ...formData, isp: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    >
                      <option value="Netix">Netix</option>
                      <option value="Airtel">Airtel</option>
                      <option value="Jio">Jio</option>
                      <option value="Spectra">Spectra</option>
                      <option value="Timble">Timble</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Managed By</label>
                    <select
                      value={formData.managed_by}
                      onChange={(e) => setFormData({ ...formData, managed_by: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    >
                      <option value="Netix">Netix</option>
                      <option value="Airtel">Airtel</option>
                      <option value="Jio">Jio</option>
                      <option value="Spectra">Spectra</option>
                      <option value="Timble">Timble</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Service Type</label>
                    <select
                      value={formData.service}
                      onChange={(e) => setFormData({ ...formData, service: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                    >
                      <option value="Lease Line">Lease Line</option>
                      <option value="Broadband">Broadband</option>
                      <option value="VOIP">VOIP</option>
                      <option value="Enterprise Broadband">Enterprise Broadband</option>
                    </select>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5 flex items-center gap-2">
                      <Building2 className="h-4 w-4 text-indigo-600" />
                      Backend Partner
                    </label>
                    <select
                      value={formData.backend_partner}
                      onChange={(e) => setFormData({ ...formData, backend_partner: e.target.value })}
                      className="w-full px-3 py-2 border border-indigo-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 text-sm bg-indigo-50"
                    >
                      <option value="Netix">Netix</option>
                      <option value="Timbl">Timbl</option>
                      <option value="Bharti Airtel">Bharti Airtel</option>
                      <option value="Jio">Jio</option>
                      <option value="LCO">LCO</option>
                    </select>
                    <p className="text-xs text-indigo-600 mt-1">
                      🔗 Customer will appear under this partner in Partner Dashboard
                    </p>
                  </div>
                  {['Broadband', 'Enterprise Broadband'].includes(formData.service) && (
                    <>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Broadband Account Number</label>
                    <Input
                      value={formData.broadband_account_number || ''}
                      onChange={(e) => setFormData({ ...formData, broadband_account_number: e.target.value })}
                      placeholder="e.g., BB123456789"
                      className="w-full"
                      data-testid="broadband-account-input"
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Last Recharge Date</label>
                      <Input
                        type="date"
                        value={formData.last_recharge_date || ''}
                        onChange={(e) => setFormData({ ...formData, last_recharge_date: e.target.value })}
                        className="w-full"
                        data-testid="last-recharge-date-input"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Recharge Amount (₹)</label>
                      <Input
                        type="number"
                        min="0"
                        value={formData.last_recharge_amount ?? ''}
                        onChange={(e) => setFormData({ ...formData, last_recharge_amount: e.target.value })}
                        placeholder="e.g., 599"
                        className="w-full"
                        data-testid="recharge-amount-input"
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Plan</label>
                      <select
                        value={formData.plan_speed || ''}
                        onChange={(e) => setFormData({ ...formData, plan_speed: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        data-testid="plan-speed-select"
                      >
                        <option value="">Select Plan</option>
                        <option value="30 Mbps">30 Mbps</option>
                        <option value="40 Mbps">40 Mbps</option>
                        <option value="50 Mbps">50 Mbps</option>
                        <option value="70 Mbps">70 Mbps</option>
                        <option value="100 Mbps">100 Mbps</option>
                        <option value="150 Mbps">150 Mbps</option>
                        <option value="200 Mbps">200 Mbps</option>
                        <option value="300 Mbps">300 Mbps</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1.5">Plan Duration</label>
                      <select
                        value={formData.plan_duration_months ?? ''}
                        onChange={(e) => setFormData({ ...formData, plan_duration_months: e.target.value })}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                        data-testid="plan-duration-select"
                      >
                        <option value="">Select Duration</option>
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((m) => (
                          <option key={m} value={m}>{m} {m === 1 ? 'Month' : 'Months'}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                    </>
                  )}
                </div>
              </div>

              {/* Router Information - New Section */}
              <div className="space-y-3 pt-3 border-t">
                <h3 className="text-sm font-semibold text-gray-700 flex items-center gap-2">
                  <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                  </svg>
                  Router Information (Optional)
                </h3>
                <div className="grid grid-cols-1 gap-3">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Router Name</label>
                    <Input
                      value={formData.router_name || ''}
                      onChange={(e) => setFormData({ ...formData, router_name: e.target.value })}
                      placeholder="Main Gateway Router"
                      className="w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Router Model</label>
                    <Input
                      value={formData.router_model || ''}
                      onChange={(e) => setFormData({ ...formData, router_model: e.target.value })}
                      placeholder="e.g., Tenda AC10, TP-Link Archer C6"
                      className="w-full"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Router IP Address</label>
                    <Input
                      value={formData.router_ip || ''}
                      onChange={(e) => setFormData({ ...formData, router_ip: e.target.value })}
                      placeholder="192.168.1.1 or 2001:db8::1"
                      className="w-full"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                      Enter router&apos;s local IP (IPv4 or IPv6)
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Router Username</label>
                    <Input
                      value={formData.router_username || ''}
                      onChange={(e) => setFormData({ ...formData, router_username: e.target.value })}
                      placeholder="admin"
                      className="w-full"
                      autoComplete="off"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1.5">Router Password</label>
                    <div className="relative">
                      <Input
                        type={showRouterPassword ? "text" : "password"}
                        value={formData.router_password || ''}
                        onChange={(e) => setFormData({ ...formData, router_password: e.target.value })}
                        placeholder="••••••••"
                        className="w-full pr-10"
                        autoComplete="new-password"
                      />
                      <button
                        type="button"
                        onClick={() => setShowRouterPassword(!showRouterPassword)}
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                      >
                        {showRouterPassword ? (
                          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                          </svg>
                        ) : (
                          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                        )}
                      </button>
                    </div>
                    <p className="text-xs text-gray-500 mt-1">
                      🔒 Password will be encrypted and stored securely
                    </p>
                  </div>
                </div>
              </div>

              {/* Status */}
              <div className="pt-3 border-t space-y-3">
                <div className="flex items-center gap-2 p-3 bg-orange-50 rounded-lg border border-orange-200">
                  <input
                    type="checkbox"
                    id="suspended"
                    checked={formData.is_suspended}
                    onChange={(e) => setFormData({ ...formData, is_suspended: e.target.checked })}
                    className="w-4 h-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500"
                  />
                  <label htmlFor="suspended" className="text-sm font-medium text-orange-900 cursor-pointer">
                    ⚠️ Mark as Suspended (Service Inactive)
                  </label>
                </div>
                
                {userPermissions.can_manage_users && (
                  <div className="flex items-center gap-2 p-3 bg-green-50 rounded-lg border border-green-200">
                    <input
                      type="checkbox"
                      id="ticketApproved"
                      checked={formData.ticket_approved || false}
                      onChange={(e) => setFormData({ ...formData, ticket_approved: e.target.checked })}
                      className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                    />
                    <label htmlFor="ticketApproved" className="text-sm font-medium text-green-900 cursor-pointer">
                      ✅ Allow Sub-users to Create Tickets for this Customer
                    </label>
                  </div>
                )}
              </div>
            </div>
            <div className="flex gap-3 pt-4 border-t sticky bottom-0 bg-white">
              <Button 
                onClick={() => {
                  setShowAddModal(false);
                  setEditingCustomer(null);
                  setFormData({
                    customer_name: '',
                    office_name: '',
                    static_ip: '',
                    city: '',
                    state: '',
                    email: '',
                    is_suspended: false,
                    isp: 'Netix',
                    managed_by: 'Netix',
                    service: 'Lease Line',
                    router_name: '',
                    router_model: '',
                    router_ip: '',
                    router_username: '',
                    router_password: ''
                  });
                  setShowRouterPassword(false);
                }} 
                variant="outline" 
                className="flex-1 h-11"
              >
                Cancel
              </Button>
              <Button 
                onClick={handleSaveCustomer} 
                disabled={loading} 
                className="flex-1 h-11 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <RefreshCw className="h-4 w-4 animate-spin" />
                    Saving...
                  </span>
                ) : (
                  <span className="flex items-center gap-2">
                    {editingCustomer ? '✓ Update Customer' : '+ Add Customer'}
                  </span>
                )}
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Router Credentials Copy-Paste Helper Modal */}
      {showRouterModal && routerCredentials && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-xl shadow-2xl p-6 max-w-md w-full">
            <div className="flex items-center justify-between mb-4 pb-3 border-b">
              <div className="flex items-center gap-2">
                <LogIn className="h-5 w-5 text-blue-600" />
                <h2 className="text-xl font-bold">Router Login Helper</h2>
              </div>
              <button 
                onClick={() => {
                  setShowRouterModal(false);
                  setRouterCredentials(null);
                }}
                className="text-gray-400 hover:text-gray-600"
              >
                ✕
              </button>
            </div>

            <div className="space-y-4">
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-sm text-blue-800 flex items-center gap-2">
                  <ExternalLink className="h-4 w-4" />
                  Router login page opened in a new tab
                </p>
              </div>

              <div className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Customer
                  </label>
                  <div className="text-sm font-semibold text-gray-900">
                    {routerCredentials.customer_name}
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Router IP
                  </label>
                  <div className="flex items-center gap-2">
                    <code className="flex-1 bg-gray-100 px-3 py-2 rounded text-sm font-mono">
                      {routerCredentials.router_ip}
                    </code>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Username
                  </label>
                  <div className="flex items-center gap-2">
                    <code className="flex-1 bg-gray-100 px-3 py-2 rounded text-sm font-mono">
                      {routerCredentials.router_username}
                    </code>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => handleCopyToClipboard(routerCredentials.router_username, 'Username')}
                      className="flex items-center gap-1"
                    >
                      {copiedField === 'Username' ? (
                        <>
                          <CheckCircle className="h-4 w-4 text-green-600" />
                          <span className="text-green-600">Copied!</span>
                        </>
                      ) : (
                        <>
                          <Copy className="h-4 w-4" />
                          Copy
                        </>
                      )}
                    </Button>
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1.5">
                    Password
                  </label>
                  <div className="flex items-center gap-2">
                    <code className="flex-1 bg-gray-100 px-3 py-2 rounded text-sm font-mono">
                      {routerCredentials.router_password}
                    </code>
                    <Button
                      size="sm"
                      variant="outline"
                      onClick={() => handleCopyToClipboard(routerCredentials.router_password, 'Password')}
                      className="flex items-center gap-1"
                    >
                      {copiedField === 'Password' ? (
                        <>
                          <CheckCircle className="h-4 w-4 text-green-600" />
                          <span className="text-green-600">Copied!</span>
                        </>
                      ) : (
                        <>
                          <Copy className="h-4 w-4" />
                          Copy
                        </>
                      )}
                    </Button>
                  </div>
                </div>
              </div>

              <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3 mt-4">
                <p className="text-xs text-yellow-800">
                  <strong>Security Note:</strong> Use the copy buttons to safely paste credentials into the router login form. This window will close automatically when you&apos;re done.
                </p>
              </div>

              <div className="flex gap-2 pt-2">
                <Button 
                  onClick={() => {
                    setShowRouterModal(false);
                    setRouterCredentials(null);
                  }}
                  className="flex-1 bg-blue-600 hover:bg-blue-700"
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Log Ticket Modal */}
      {showLogTicketModal && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="bg-gradient-to-r from-orange-500 to-red-500 p-5 rounded-t-xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg">
                    <Ticket className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-white">Log New Ticket</h2>
                    <p className="text-white/80 text-sm">Submit a support request</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowLogTicketModal(false)}
                  className="text-white/80 hover:text-white"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-4">
              {/* Customer Selection */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Select Customer <span className="text-red-500">*</span>
                </label>
                <select
                  value={ticketFormData.customer_id}
                  onChange={(e) => {
                    const selectedCustomer = customers.find(c => c.id === e.target.value);
                    setTicketFormData({
                      ...ticketFormData,
                      customer_id: e.target.value,
                      customer_name: selectedCustomer?.customer_name || '',
                      customer_ip: selectedCustomer?.static_ip || '',
                      customer_email: selectedCustomer?.email || ''
                    });
                  }}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  <option value="">-- Choose Customer --</option>
                  {(userPermissions.can_manage_users ? customers : customers.filter(c => c.ticket_approved))
                    .map((customer) => (
                      <option key={customer.id} value={customer.id}>
                        {customer.customer_name} ({customer.static_ip})
                      </option>
                    ))}
                </select>
                {!userPermissions.can_manage_users && customers.filter(c => c.ticket_approved).length === 0 && (
                  <p className="text-sm text-amber-600 mt-2">
                    No customers approved for ticket creation. Contact admin for access.
                  </p>
                )}
              </div>

              {/* Category */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Category <span className="text-red-500">*</span>
                </label>
                <select
                  value={ticketFormData.category}
                  onChange={(e) => setTicketFormData({...ticketFormData, category: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  <option value="Technical">🔧 Technical Issue</option>
                  <option value="Billing">💰 Billing</option>
                  <option value="Network">📡 Network</option>
                  <option value="Installation">🔌 Installation</option>
                  <option value="General">❓ General Query</option>
                </select>
              </div>

              {/* Priority */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Priority <span className="text-red-500">*</span>
                </label>
                <select
                  value={ticketFormData.priority}
                  onChange={(e) => setTicketFormData({...ticketFormData, priority: e.target.value})}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                >
                  <option value="Low">🟢 Low</option>
                  <option value="Medium">🟡 Medium</option>
                  <option value="High">🟠 High</option>
                  <option value="Critical">🔴 Critical</option>
                </select>
              </div>

              {/* Subject */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Subject <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={ticketFormData.subject}
                  onChange={(e) => setTicketFormData({...ticketFormData, subject: e.target.value})}
                  placeholder="Brief description of the issue"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                />
              </div>

              {/* Description */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Description <span className="text-red-500">*</span>
                </label>
                <textarea
                  value={ticketFormData.description}
                  onChange={(e) => setTicketFormData({...ticketFormData, description: e.target.value})}
                  placeholder="Provide detailed information about the issue..."
                  rows={5}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-orange-500 focus:border-transparent resize-none"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 pt-4">
                <Button
                  onClick={() => setShowLogTicketModal(false)}
                  variant="outline"
                  className="flex-1"
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleLogTicket}
                  className="flex-1 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white"
                >
                  Submit Ticket
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Ticket Detail Modal */}
      {showTicketDetailModal && selectedTicket && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
            <div className="bg-gradient-to-r from-blue-600 to-purple-600 p-5">
              <div className="flex items-center justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-1">
                    <span className="font-mono text-lg font-bold text-white">
                      {selectedTicket.ticket_id}
                    </span>
                    {selectedTicket.is_overdue && (
                      <span className="px-2 py-0.5 bg-red-500 text-white text-xs rounded-full font-semibold">
                        OVERDUE
                      </span>
                    )}
                  </div>
                  <h3 className="text-xl font-semibold text-white">{selectedTicket.subject}</h3>
                  <p className="text-white/80 text-sm mt-1">{selectedTicket.customer_name}</p>
                </div>
                <button
                  onClick={() => setShowTicketDetailModal(false)}
                  className="text-white/80 hover:text-white"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-6 space-y-6">
              {/* Description */}
              <div>
                <h4 className="font-semibold text-gray-900 mb-2">Description</h4>
                <p className="text-gray-700 bg-gray-50 rounded-lg p-4 whitespace-pre-wrap">
                  {selectedTicket.description}
                </p>
              </div>

              {/* Ticket Info */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                <div className="bg-blue-50 rounded-lg p-3 border border-blue-200">
                  <div className="text-xs text-gray-600 mb-1">Priority</div>
                  <div className={`text-sm font-semibold ${
                    selectedTicket.priority === 'Critical' ? 'text-red-600' :
                    selectedTicket.priority === 'High' ? 'text-orange-600' :
                    selectedTicket.priority === 'Medium' ? 'text-yellow-600' :
                    'text-green-600'
                  }`}>
                    {selectedTicket.priority}
                  </div>
                </div>
                <div className="bg-purple-50 rounded-lg p-3 border border-purple-200">
                  <div className="text-xs text-gray-600 mb-1">Status</div>
                  <div className="text-sm font-semibold text-purple-600">
                    {selectedTicket.status}
                  </div>
                </div>
                <div className="bg-green-50 rounded-lg p-3 border border-green-200">
                  <div className="text-xs text-gray-600 mb-1">Category</div>
                  <div className="text-sm font-semibold text-green-600">
                    {selectedTicket.category}
                  </div>
                </div>
                <div className="bg-orange-50 rounded-lg p-3 border border-orange-200">
                  <div className="text-xs text-gray-600 mb-1">Age</div>
                  <div className="text-sm font-semibold text-orange-600">
                    {Math.floor(selectedTicket.age_minutes / 60) > 0 
                      ? `${Math.floor(selectedTicket.age_minutes / 60)}h`
                      : `${selectedTicket.age_minutes}m`}
                  </div>
                </div>
              </div>

              {/* Conversation */}
              <div>
                <h4 className="font-semibold text-gray-900 mb-3 flex items-center gap-2">
                  <MessageSquare className="h-5 w-5" />
                  Conversation ({ticketReplies.length})
                </h4>
                <div className="space-y-3">
                  {ticketReplies.length === 0 ? (
                    <p className="text-gray-500 text-center py-4 bg-gray-50 rounded-lg">No replies yet</p>
                  ) : (
                    ticketReplies.map((reply) => (
                      <div
                        key={reply.reply_id}
                        className={`p-4 rounded-lg ${
                          reply.author_role === 'admin'
                            ? 'bg-blue-50 border-l-4 border-blue-500'
                            : 'bg-gray-50 border-l-4 border-gray-300'
                        }`}
                      >
                        <div className="flex items-start justify-between mb-2">
                          <div className="flex items-center gap-2">
                            <User className="h-4 w-4 text-gray-500" />
                            <span className="font-medium text-sm">{reply.author_name}</span>
                            <span className="text-xs text-gray-500">({reply.author_role})</span>
                          </div>
                          <span className="text-xs text-gray-500">
                            {new Date(reply.created_at).toLocaleString()}
                          </span>
                        </div>
                        <p className="text-gray-700 text-sm whitespace-pre-wrap">{reply.message}</p>
                      </div>
                    ))
                  )}
                </div>
              </div>

              {/* Reply Input */}
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">Add Reply</label>
                <textarea
                  value={replyMessage}
                  onChange={(e) => setReplyMessage(e.target.value)}
                  placeholder="Type your reply..."
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
                />
              </div>
            </div>

            {/* Footer Actions */}
            <div className="bg-gray-50 p-4 flex items-center justify-between gap-3 border-t">
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium text-gray-700">Status:</label>
                <select
                  value={selectedTicket.status}
                  onChange={(e) => {
                    setSelectedTicket({...selectedTicket, status: e.target.value});
                  }}
                  className="border border-gray-300 rounded px-3 py-1.5 text-sm"
                >
                  <option value="Open">Open</option>
                  <option value="In Progress">In Progress</option>
                  <option value="On Hold">On Hold</option>
                  <option value="Resolved">Resolved</option>
                  <option value="Closed">Closed</option>
                </select>
                <Button
                  size="sm"
                  onClick={() => handleUpdateTicketStatus(selectedTicket.ticket_id, selectedTicket.status)}
                  className="bg-green-600 hover:bg-green-700"
                >
                  <CheckCircle className="h-4 w-4 mr-1" />
                  Update Status
                </Button>
              </div>
              <Button
                onClick={handleSendReply}
                disabled={sendingReply || !replyMessage.trim()}
                className="bg-blue-600 hover:bg-blue-700"
              >
                {sendingReply ? (
                  <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                ) : (
                  <Send className="h-4 w-4 mr-2" />
                )}
                Send Reply
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Router Control Panel Modal */}
      {showRouterControlModal && selectedRouterCustomer && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
            <div className="bg-gradient-to-r from-purple-600 to-indigo-600 p-5 rounded-t-xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="bg-white/20 backdrop-blur-sm p-2 rounded-lg">
                    <Settings className="h-6 w-6 text-white" />
                  </div>
                  <div>
                    <h2 className="text-xl font-bold text-white">Router Control</h2>
                    <p className="text-white/80 text-sm">{selectedRouterCustomer.customer_name}</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowRouterControlModal(false)}
                  className="text-white/80 hover:text-white"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            <div className="p-6 space-y-4">
              {/* Router Info */}
              <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
                <div className="text-sm text-gray-600 mb-1">Router IP</div>
                <div className="font-mono text-sm font-semibold">{selectedRouterCustomer.router_ip}</div>
                <div className="text-xs text-gray-500 mt-1">{selectedRouterCustomer.router_model || 'Unknown Model'}</div>
              </div>

              {/* Mode Indicator */}
              <div className={`p-3 rounded-lg border ${routerMockMode ? 'bg-amber-50 border-amber-200' : 'bg-green-50 border-green-200'}`}>
                <div className="flex items-center gap-2">
                  <div className={`w-2 h-2 rounded-full ${routerMockMode ? 'bg-amber-500' : 'bg-green-500'} animate-pulse`}></div>
                  <span className={`text-sm font-semibold ${routerMockMode ? 'text-amber-800' : 'text-green-800'}`}>
                    {routerMockMode ? 'MOCK MODE' : 'REAL MODE'}
                  </span>
                </div>
                <p className="text-xs text-gray-600 mt-1">
                  {routerMockMode 
                    ? 'Testing mode - No actual commands sent to router' 
                    : 'Live mode - Commands will be sent to real router'}
                </p>
              </div>

              {/* Control Buttons */}
              <div className="space-y-3">
                <Button
                  onClick={() => handleRebootRouter(selectedRouterCustomer)}
                  disabled={routerActionInProgress}
                  className="w-full bg-orange-500 hover:bg-orange-600 text-white flex items-center justify-center gap-2"
                >
                  <Power className="h-4 w-4" />
                  Reboot Router
                </Button>

                <div className="grid grid-cols-2 gap-3">
                  <Button
                    onClick={() => handleWANControl(selectedRouterCustomer, 'enable')}
                    disabled={routerActionInProgress}
                    className="bg-green-500 hover:bg-green-600 text-white flex items-center justify-center gap-2"
                  >
                    <Wifi className="h-4 w-4" />
                    WAN ON
                  </Button>
                  <Button
                    onClick={() => handleWANControl(selectedRouterCustomer, 'disable')}
                    disabled={routerActionInProgress}
                    className="bg-red-500 hover:bg-red-600 text-white flex items-center justify-center gap-2"
                  >
                    <WifiOff className="h-4 w-4" />
                    WAN OFF
                  </Button>
                </div>

                <Button
                  onClick={() => {
                    setShowRouterControlModal(false);
                    handleFetchRouterLogs(selectedRouterCustomer);
                  }}
                  disabled={routerActionInProgress}
                  variant="outline"
                  className="w-full flex items-center justify-center gap-2"
                >
                  <FileText className="h-4 w-4" />
                  View Router Logs
                </Button>
              </div>

              <div className="pt-3 border-t">
                <Button
                  onClick={() => setShowRouterControlModal(false)}
                  variant="outline"
                  className="w-full"
                >
                  Close
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Router Logs Modal */}
      {showRouterLogsModal && selectedRouterCustomer && (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[80vh] flex flex-col">
            <div className="bg-gradient-to-r from-blue-600 to-cyan-600 p-5 rounded-t-xl">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <FileText className="h-6 w-6 text-white" />
                  <div>
                    <h2 className="text-xl font-bold text-white">Router System Logs</h2>
                    <p className="text-white/80 text-sm">{selectedRouterCustomer.customer_name}</p>
                  </div>
                </div>
                <button
                  onClick={() => setShowRouterLogsModal(false)}
                  className="text-white/80 hover:text-white"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
            </div>

            <div className="flex-1 overflow-y-auto p-6">
              <pre className="bg-gray-900 text-green-400 p-4 rounded-lg text-xs font-mono whitespace-pre-wrap">
                {routerLogs}
              </pre>
            </div>

            <div className="p-4 border-t flex gap-3">
              <Button
                onClick={() => setShowRouterLogsModal(false)}
                variant="outline"
                className="flex-1"
              >
                Close
              </Button>
              <Button
                onClick={() => handleFetchRouterLogs(selectedRouterCustomer)}
                className="flex-1 bg-blue-600 hover:bg-blue-700"
              >
                <RefreshCw className="h-4 w-4 mr-2" />
                Refresh Logs
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Confirmation Dialog */}
      {showConfirmDialog && confirmAction && (
        <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-[10000] p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-md w-full">
            <div className="p-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-orange-100 rounded-full p-3">
                  <AlertCircle className="h-6 w-6 text-orange-600" />
                </div>
                <h3 className="text-xl font-bold text-gray-900">{confirmAction.title}</h3>
              </div>
              <p className="text-gray-700 mb-6">{confirmAction.message}</p>
              <div className="flex gap-3">
                <Button
                  onClick={() => setShowConfirmDialog(false)}
                  variant="outline"
                  className="flex-1"
                >
                  Cancel
                </Button>
                <Button
                  onClick={confirmAction.action}
                  className="flex-1 bg-orange-600 hover:bg-orange-700 text-white"
                >
                  Confirm
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Announcement Management Modal */}
      {showAnnouncementModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full">
            <div className="bg-gradient-to-r from-yellow-400 to-orange-500 text-white px-6 py-4 rounded-t-xl">
              <h2 className="text-2xl font-bold flex items-center gap-2">
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"/>
                </svg>
                Manage Announcement
              </h2>
              <p className="text-white/90 text-sm mt-1">Create or update the announcement message displayed to all users</p>
            </div>
            
            <div className="p-6">
              <div className="mb-6">
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Announcement Message
                </label>
                <textarea
                  value={announcementInput}
                  onChange={(e) => setAnnouncementInput(e.target.value)}
                  placeholder="Enter your announcement message here..."
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all resize-none"
                  rows={4}
                />
                <p className="text-xs text-gray-500 mt-2">
                  💡 Tip: Keep it concise and informative. The message will scroll from right to left.
                </p>
              </div>

              <div className="bg-yellow-50 border-2 border-yellow-200 rounded-lg p-4 mb-6">
                <p className="text-sm text-gray-700 font-semibold mb-2">Preview:</p>
                <div className="overflow-hidden bg-gradient-to-r from-yellow-400 via-orange-400 to-red-400 rounded-lg p-3">
                  <div className="animate-marquee whitespace-nowrap">
                    <span className="text-white font-semibold drop-shadow-md">
                      {announcementInput || 'Your announcement will appear here...'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex gap-3">
                <Button
                  onClick={saveAnnouncement}
                  disabled={!announcementInput.trim()}
                  className="flex-1 bg-gradient-to-r from-yellow-500 to-orange-500 text-white hover:from-yellow-600 hover:to-orange-600 disabled:opacity-50"
                >
                  💾 Save Announcement
                </Button>
                {announcement.is_active && (
                  <Button
                    onClick={deleteAnnouncement}
                    className="bg-red-500 text-white hover:bg-red-600"
                  >
                    🗑️ Remove
                  </Button>
                )}
                <Button
                  onClick={() => setShowAnnouncementModal(false)}
                  variant="outline"
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="mt-12 bg-gradient-to-r from-slate-800 via-slate-900 to-slate-800 text-white rounded-xl shadow-2xl overflow-hidden">
        <div className="p-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <img src="/netix-logo-horizontal.png" alt="Netix Fibernet" className="h-10 w-auto brightness-0 invert" />
              </div>
              <p className="text-slate-300 text-sm font-medium">
                Netix World Internet Services Private Limited
              </p>
              <p className="text-slate-400 text-xs">
                Providing high-speed fiber internet across India
              </p>
            </div>

            {/* Contact Support */}
            <div className="space-y-4">
              <h3 className="text-lg font-bold text-white flex items-center gap-2">
                <Mail className="h-5 w-5 text-blue-400" />
                Support
              </h3>
              <div className="space-y-2">
                <a href="mailto:care@netixfibernet.com" className="flex items-center gap-2 text-slate-300 hover:text-blue-400 transition-colors text-sm">
                  <span className="text-blue-400">Customer Care:</span> care@netixfibernet.com
                </a>
                <a href="mailto:data@netixfibernet.com" className="flex items-center gap-2 text-slate-300 hover:text-blue-400 transition-colors text-sm">
                  <span className="text-blue-400">Data Support:</span> data@netixfibernet.com
                </a>
              </div>
            </div>

            {/* Contact Numbers */}
            <div className="space-y-4">
              <h3 className="text-lg font-bold text-white flex items-center gap-2">
                <Phone className="h-5 w-5 text-green-400" />
                Call Us
              </h3>
              <div className="space-y-2">
                <a href="tel:+919319919988" data-testid="monitoring-footer-mobile-link" className="flex items-center gap-2 text-slate-300 hover:text-green-400 transition-colors text-sm">
                  📞 +91 93199 19988
                </a>
                <a href="tel:06276459015" data-testid="monitoring-footer-office-link" className="flex items-center gap-2 text-slate-300 hover:text-green-400 transition-colors text-sm">
                  ☎️ Office Phone - 06276 - 459015
                </a>
              </div>
            </div>

            {/* Office Locations */}
            <div className="space-y-4">
              <h3 className="text-lg font-bold text-white flex items-center gap-2">
                <MapPin className="h-5 w-5 text-red-400" />
                Our Offices
              </h3>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-slate-700 rounded-full text-xs text-slate-300">Delhi</span>
                <span className="px-3 py-1 bg-slate-700 rounded-full text-xs text-slate-300">Bihar</span>
                <span className="px-3 py-1 bg-slate-700 rounded-full text-xs text-slate-300">Haryana</span>
                <span className="px-3 py-1 bg-slate-700 rounded-full text-xs text-slate-300">Uttar Pradesh</span>
              </div>
              <a href="https://www.netixfibernet.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-blue-400 hover:text-blue-300 transition-colors text-sm mt-2">
                <Globe className="h-4 w-4" />
                www.netixfibernet.com
              </a>
            </div>
          </div>
        </div>
        
        {/* Certifications Strip */}
        <div className="px-8 pb-8" data-testid="monitoring-footer-certifications-strip">
          <div className="border-t border-slate-700 pt-6 flex flex-col md:flex-row md:items-center md:justify-center gap-6 md:gap-12">
            <div className="flex items-center gap-3" data-testid="monitoring-footer-iso-certification">
              <img
                src="/badges/iso-9001-2015.png"
                alt="ISO 9001:2015 Certified - Quality Management System"
                className="h-20 w-20 object-contain flex-shrink-0"
                loading="lazy"
              />
              <div>
                <p className="text-base font-bold text-yellow-400">ISO 9001:2015</p>
                <p className="text-sm text-slate-400">Quality Management System</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-testid="monitoring-footer-iso-27001-certification">
              <img
                src="/badges/iso-27001-2022.png"
                alt="ISO/IEC 27001:2022 Certified - Information Security Management"
                className="h-20 w-20 object-contain flex-shrink-0"
                loading="lazy"
              />
              <div>
                <p className="text-base font-bold text-yellow-400">ISO/IEC 27001:2022</p>
                <p className="text-sm text-slate-400">Information Security Management</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-testid="monitoring-footer-msme-certification">
              <img
                src="/badges/msme.png"
                alt="MSME Registered - Govt. of India"
                className="h-20 w-20 object-contain flex-shrink-0"
                loading="lazy"
              />
              <div>
                <p className="text-base font-bold text-yellow-400">MSME Registered</p>
                <p className="text-sm text-slate-400">Govt. of India</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-testid="monitoring-footer-mca-certification">
              <img
                src="/badges/mca-incorporation.png"
                alt="Certificate of Incorporation - Ministry of Corporate Affairs"
                className="h-20 w-20 object-contain flex-shrink-0"
                loading="lazy"
              />
              <div>
                <p className="text-base font-bold text-yellow-400">Certificate of Incorporation</p>
                <p className="text-sm text-slate-400">Ministry of Corporate Affairs</p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="bg-slate-900/50 px-8 py-4 border-t border-slate-700">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2 text-xs text-slate-400">
            <p>© {new Date().getFullYear()} Netix Fibernet. All rights reserved.</p>
            <p>IP Monitoring Dashboard v2.0</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default CustomerMonitoring;
